"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2575],{

/***/ 4930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Label; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40549);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94581);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2734);
// @mui



var RootStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("span")(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    var isLight = theme.palette.mode === "light";
    var color = ownerState.color, variant = ownerState.variant;
    var styleFilled = function(color) {
        return {
            color: theme.palette[color].contrastText,
            backgroundColor: theme.palette[color].main
        };
    };
    var styleOutlined = function(color) {
        return {
            color: theme.palette[color].main,
            backgroundColor: "transparent",
            border: "1px solid ".concat(theme.palette[color].main)
        };
    };
    var styleGhost = function(color) {
        return {
            color: theme.palette[color][isLight ? "dark" : "light"],
            backgroundColor: (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette[color].main, 0.16)
        };
    };
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        height: 22,
        minWidth: 22,
        lineHeight: 0,
        borderRadius: 6,
        cursor: "default",
        alignItems: "center",
        whiteSpace: "nowrap",
        display: "inline-flex",
        justifyContent: "center",
        padding: theme.spacing(0, 1),
        color: theme.palette.grey[800],
        fontSize: theme.typography.pxToRem(12),
        fontFamily: theme.typography.fontFamily,
        backgroundColor: theme.palette.grey[300],
        fontWeight: theme.typography.fontWeightBold
    }, color !== "default" ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, variant === "filled" && (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, styleFilled(color)), variant === "outlined" && (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, styleOutlined(color)), variant === "ghost" && (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, styleGhost(color))) : (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, variant === "outlined" && {
        backgroundColor: "transparent",
        color: theme.palette.text.primary,
        border: "1px solid ".concat(theme.palette.grey[50032])
    }, variant === "ghost" && {
        color: isLight ? theme.palette.text.secondary : theme.palette.common.white,
        backgroundColor: theme.palette.grey[50016]
    }));
});
function Label(param) {
    var _color = param.color, color = _color === void 0 ? "default" : _color, _variant = param.variant, variant = _variant === void 0 ? "ghost" : _variant, children = param.children, sx = param.sx;
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RootStyle, {
        ownerState: {
            color: color,
            variant: variant
        },
        sx: sx,
        theme: theme,
        children: children
    });
}


/***/ }),

/***/ 58432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SvgIconStyle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36822);



function SvgIconStyle(param) {
    var src = param.src, sx = param.sx;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        component: "span",
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            width: 24,
            height: 24,
            display: "inline-block",
            bgcolor: "currentColor",
            mask: "url(".concat(src, ") no-repeat center / contain"),
            WebkitMask: "url(".concat(src, ") no-repeat center / contain")
        }, sx)
    });
}


/***/ }),

/***/ 67854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _contexts_CollapseDrawerContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44237);


// ----------------------------------------------------------------------
var useCollapseDrawer = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_contexts_CollapseDrawerContext__WEBPACK_IMPORTED_MODULE_1__/* .CollapseDrawerContext */ .y);
};
/* harmony default export */ __webpack_exports__["Z"] = (useCollapseDrawer);


/***/ }),

/***/ 72575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/layouts/main/index.tsx + 7 modules
var main = __webpack_require__(89809);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(40549);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./src/hooks/useSettings.ts
var useSettings = __webpack_require__(10901);
// EXTERNAL MODULE: ./src/hooks/useResponsive.ts
var useResponsive = __webpack_require__(10653);
// EXTERNAL MODULE: ./src/hooks/useCollapseDrawer.ts
var useCollapseDrawer = __webpack_require__(67854);
// EXTERNAL MODULE: ./src/config.ts
var config = __webpack_require__(86704);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@mui/material/AppBar/AppBar.js + 1 modules
var AppBar = __webpack_require__(42293);
// EXTERNAL MODULE: ./node_modules/@mui/material/Toolbar/Toolbar.js + 1 modules
var Toolbar = __webpack_require__(10155);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./src/hooks/useOffSetTop.ts
var useOffSetTop = __webpack_require__(92821);
// EXTERNAL MODULE: ./src/utils/cssStyles.ts
var cssStyles = __webpack_require__(20727);
// EXTERNAL MODULE: ./src/components/Logo.tsx
var Logo = __webpack_require__(74608);
// EXTERNAL MODULE: ./src/components/Iconify.tsx
var Iconify = __webpack_require__(42445);
// EXTERNAL MODULE: ./src/components/animate/index.ts + 12 modules
var animate = __webpack_require__(76843);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/base/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(90970);
// EXTERNAL MODULE: ./node_modules/@mui/material/Slide/Slide.js
var Slide = __webpack_require__(54776);
// EXTERNAL MODULE: ./node_modules/@mui/material/Input/Input.js
var Input = __webpack_require__(79332);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(87109);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
;// CONCATENATED MODULE: ./src/layouts/dashboard/header/Searchbar.tsx





// @mui


// utils

// components


// ----------------------------------------------------------------------
var APPBAR_MOBILE = 64;
var APPBAR_DESKTOP = 92;
var SearchbarStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,cssStyles/* default */.Z)(theme).bgBlur()), (0,_define_property/* default */.Z)({
        top: 0,
        left: 0,
        zIndex: 99,
        width: "100%",
        display: "flex",
        position: "absolute",
        alignItems: "center",
        height: APPBAR_MOBILE,
        padding: theme.spacing(0, 3),
        boxShadow: theme.customShadows.z8
    }, theme.breakpoints.up("md"), {
        height: APPBAR_DESKTOP,
        padding: theme.spacing(0, 5)
    }));
});
// ----------------------------------------------------------------------
function Searchbar() {
    var ref = (0,react.useState)(false), isOpen = ref[0], setOpen = ref[1];
    var handleOpen = function() {
        setOpen(function(prev) {
            return !prev;
        });
    };
    var handleClose = function() {
        setOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
        onClickAway: handleClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                !isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(animate/* IconButtonAnimate */.w_, {
                    onClick: handleOpen,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                        icon: "eva:search-fill",
                        width: 20,
                        height: 20
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Slide/* default */.Z, {
                    direction: "down",
                    in: isOpen,
                    mountOnEnter: true,
                    unmountOnExit: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchbarStyle, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                autoFocus: true,
                                fullWidth: true,
                                disableUnderline: true,
                                placeholder: "Search…",
                                startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                    position: "start",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                        icon: "eva:search-fill",
                                        sx: {
                                            color: "text.disabled",
                                            width: 20,
                                            height: 20
                                        }
                                    })
                                }),
                                sx: {
                                    mr: 1,
                                    fontWeight: "fontWeightBold"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "contained",
                                onClick: handleClose,
                                children: "Search"
                            })
                        ]
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/notistack/dist/notistack.esm.js
var notistack_esm = __webpack_require__(73400);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(94581);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(18972);
// EXTERNAL MODULE: ./src/routes/paths.ts
var paths = __webpack_require__(96259);
// EXTERNAL MODULE: ./src/hooks/useAuth.ts
var useAuth = __webpack_require__(78470);
// EXTERNAL MODULE: ./src/hooks/useIsMountedRef.ts
var useIsMountedRef = __webpack_require__(60128);
// EXTERNAL MODULE: ./src/components/MyAvatar.tsx + 2 modules
var MyAvatar = __webpack_require__(65494);
// EXTERNAL MODULE: ./src/components/MenuPopover.tsx
var MenuPopover = __webpack_require__(48731);
;// CONCATENATED MODULE: ./src/layouts/dashboard/header/AccountPopover.tsx






// next


// @mui


// routes

// hooks


// components



// ----------------------------------------------------------------------
var MENU_OPTIONS = [
    {
        label: "Home",
        linkTo: "/"
    },
    {
        label: "Profile",
        linkTo: paths/* PATH_DASHBOARD.user.profile */.vB.user.profile
    },
    {
        label: "Settings",
        linkTo: paths/* PATH_DASHBOARD.user.account */.vB.user.account
    }, 
];
// ----------------------------------------------------------------------
function AccountPopover() {
    var router = (0,next_router.useRouter)();
    var ref = (0,useAuth/* default */.Z)(), user = ref.user, logout = ref.logout;
    var isMountedRef = (0,useIsMountedRef/* default */.Z)();
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var ref1 = (0,react.useState)(null), open = ref1[0], setOpen = ref1[1];
    var handleOpen = function(event) {
        setOpen(event.currentTarget);
    };
    var handleClose = function() {
        setOpen(null);
    };
    var handleLogout = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            logout()
                        ];
                    case 1:
                        _state.sent();
                        router.replace(paths/* PATH_AUTH.login */.EE.login);
                        if (isMountedRef.current) {
                            handleClose();
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.error(error);
                        enqueueSnackbar("Unable to logout!", {
                            variant: "error"
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleLogout() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(animate/* IconButtonAnimate */.w_, {
                onClick: handleOpen,
                sx: (0,_object_spread/* default */.Z)({
                    p: 0
                }, open && {
                    "&:before": {
                        zIndex: 1,
                        content: "''",
                        width: "100%",
                        height: "100%",
                        borderRadius: "50%",
                        position: "absolute",
                        bgcolor: function(theme) {
                            return (0,colorManipulator/* alpha */.Fq)(theme.palette.grey[900], 0.8);
                        }
                    }
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MyAvatar/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuPopover/* default */.Z, {
                open: Boolean(open),
                anchorEl: open,
                onClose: handleClose,
                sx: {
                    p: 0,
                    mt: 1.5,
                    ml: 0.75,
                    "& .MuiMenuItem-root": {
                        typography: "body2",
                        borderRadius: 0.75
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            my: 1.5,
                            px: 2.5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle2",
                                noWrap: true,
                                children: user === null || user === void 0 ? void 0 : user.displayName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body2",
                                sx: {
                                    color: "text.secondary"
                                },
                                noWrap: true,
                                children: user === null || user === void 0 ? void 0 : user.email
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        sx: {
                            borderStyle: "dashed"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        sx: {
                            p: 1
                        },
                        children: MENU_OPTIONS.map(function(option) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: option.linkTo,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                    onClick: handleClose,
                                    children: option.label
                                }, option.label)
                            }, option.label);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        sx: {
                            borderStyle: "dashed"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                        onClick: handleLogout,
                        sx: {
                            m: 1
                        },
                        children: "Logout"
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/layouts/dashboard/header/LanguagePopover.tsx
var LanguagePopover = __webpack_require__(15613);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemAvatar/ListItemAvatar.js + 1 modules
var ListItemAvatar = __webpack_require__(18987);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(69661);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(59334);
// EXTERNAL MODULE: ./src/utils/formatTime.ts
var formatTime = __webpack_require__(69127);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/sub/index.js + 2 modules
var sub = __webpack_require__(46038);
;// CONCATENATED MODULE: ./src/_mock/role.ts
// ----------------------------------------------------------------------
var role = [
    "UX Designer",
    "Full Stack Designer",
    "Backend Developer",
    "UX Designer",
    "UX Designer",
    "Project Manager",
    "Leader",
    "Backend Developer",
    "Project Manager",
    "UI Designer",
    "UI/UX Designer",
    "UI/UX Designer",
    "UI Designer",
    "Backend Developer",
    "Backend Developer",
    "Front End Developer",
    "Backend Developer",
    "Full Stack Designer",
    "Full Stack Developer",
    "Backend Developer",
    "UX Designer",
    "UI Designer",
    "Project Manager",
    "UI/UX Designer",
    "UI Designer",
    "Project Manager",
    "Full Stack Developer",
    "Hr Manager",
    "Hr Manager",
    "UI/UX Designer",
    "Project Manager",
    "Full Stack Designer",
    "UI Designer",
    "Leader",
    "Front End Developer",
    "UI/UX Designer",
    "Project Manager",
    "UI/UX Designer",
    "UI Designer",
    "Full Stack Designer"
];

;// CONCATENATED MODULE: ./src/_mock/email.ts
// ----------------------------------------------------------------------
var email = [
    "nannie_abernathy70@yahoo.com",
    "ashlynn_ohara62@gmail.com",
    "milo.farrell@hotmail.com",
    "violet.ratke86@yahoo.com",
    "letha_lubowitz24@yahoo.com",
    "aditya_greenfelder31@gmail.com",
    "lenna_bergnaum27@hotmail.com",
    "luella.ryan33@gmail.com",
    "joana.simonis84@gmail.com",
    "marjolaine_white94@gmail.com",
    "vergie_block82@hotmail.com",
    "vito.hudson@hotmail.com",
    "tyrel_greenholt@gmail.com",
    "dwight.block85@yahoo.com",
    "mireya13@hotmail.com",
    "dasia_jenkins@hotmail.com",
    "benny89@yahoo.com",
    "dawn.goyette@gmail.com",
    "zella_hickle4@yahoo.com",
    "avery43@hotmail.com",
    "olen_legros@gmail.com",
    "jimmie.gerhold73@hotmail.com",
    "genevieve.powlowski@hotmail.com",
    "louie.kuphal39@gmail.com",
    "enoch.cruickshank@gmail.com",
    "arlo_mccullough@gmail.com",
    "sadie18@yahoo.com",
    "aric67@gmail.com",
    "mack_deckow53@gmail.com",
    "constantin91@yahoo.com",
    "lonny84@hotmail.com",
    "gus56@hotmail.com",
    "brennon64@yahoo.com",
    "hortense.streich@hotmail.com",
    "kallie_powlowski57@hotmail.com",
    "meghan.kemmer@hotmail.com",
    "bella.mraz14@yahoo.com",
    "barney88@gmail.com",
    "diamond_johns@hotmail.com",
    "gus80@hotmail.com"
];

;// CONCATENATED MODULE: ./src/_mock/boolean.ts
// ----------------------------------------------------------------------
var boolean_boolean = [
    true,
    true,
    true,
    false,
    false,
    true,
    false,
    false,
    false,
    false,
    true,
    true,
    true,
    false,
    false,
    false,
    true,
    false,
    false,
    false,
    true,
    false,
    false,
    true,
    true,
    true,
    false,
    false,
    true,
    true,
    false,
    true,
    false,
    true,
    true,
    true,
    false,
    true,
    false,
    false
];

;// CONCATENATED MODULE: ./src/_mock/company.ts
// ----------------------------------------------------------------------
var company = [
    "Lueilwitz and Sons",
    "Gleichner, Mueller and Tromp",
    "Nikolaus - Leuschke",
    "Hegmann, Kreiger and Bayer",
    "Grimes Inc",
    "Durgan - Murazik",
    "Altenwerth, Medhurst and Roberts",
    "Raynor Group",
    "Mraz, Donnelly and Collins",
    "Padberg - Bailey",
    "Heidenreich, Stokes and Parker",
    "Pagac and Sons",
    "Rempel, Hand and Herzog",
    "Dare - Treutel",
    "Kihn, Marquardt and Crist",
    "Nolan - Kunde",
    "Wuckert Inc",
    "Dibbert Inc",
    "Goyette and Sons",
    "Feest Group",
    "Bosco and Sons",
    "Bartell - Kovacek",
    "Schimmel - Raynor",
    "Tremblay LLC",
    "Hills - Mitchell",
    "Rogahn LLC",
    "Kuhn, Osinski and Morar",
    "Schmitt Inc",
    "Breitenberg - Rosenbaum",
    "O'Keefe, Schneider and Mraz",
    "Rohan, Langworth and Kling",
    "Morar and Sons",
    "Mraz LLC",
    "Rowe, Parisian and Kub",
    "Marquardt - Hane",
    "Medhurst Group",
    "Nikolaus - Lang",
    "Effertz, Mohr and Olson",
    "Anderson - Kris",
    "Runolfsson Group"
];

;// CONCATENATED MODULE: ./src/_mock/phoneNumber.ts
// ----------------------------------------------------------------------
var phoneNumber = [
    "365-374-4961",
    "904-966-2836",
    "399-757-9909",
    "692-767-2903",
    "990-588-5716",
    "955-439-2578",
    "226-924-4058",
    "552-917-1454",
    "285-840-9338",
    "306-269-2446",
    "883-373-6253",
    "476-509-8866",
    "201-465-1954",
    "538-295-9408",
    "531-492-6028",
    "981-699-7588",
    "500-268-4826",
    "205-952-3828",
    "222-255-5190",
    "408-439-8033",
    "272-940-8266",
    "812-685-8057",
    "353-801-5212",
    "606-285-8928",
    "202-767-8621",
    "222-830-0731",
    "964-940-3166",
    "262-702-2396",
    "886-261-9789",
    "352-390-5069",
    "343-907-8334",
    "575-347-2399",
    "749-228-5604",
    "774-452-2071",
    "607-841-0447",
    "395-619-2157",
    "233-834-0373",
    "586-880-2602",
    "746-772-0722",
    "638-615-3365,"
];

;// CONCATENATED MODULE: ./src/_mock/address.ts
// ----------------------------------------------------------------------
var fullAddress = [
    "19034 Verna Unions Apt. 164 - Honolulu, RI / 87535",
    "1147 Rohan Drive Suite 819 - Burlington, VT / 82021",
    "18605 Thompson Circle Apt. 086 - Idaho Falls, WV / 50337",
    "110 Lamar Station Apt. 730 - Hagerstown, OK / 49808",
    "36901 Elmer Spurs Apt. 762 - Miramar, DE / 92836",
    "2089 Runolfsson Harbors Suite 886 - Chapel Hill, TX / 32827",
    "279 Karolann Ports Apt. 774 - Prescott Valley, WV / 53905",
    "96607 Claire Square Suite 591 - St. Louis Park, HI / 40802",
    "9388 Auer Station Suite 573 - Honolulu, AK / 98024",
    "47665 Adaline Squares Suite 510 - Blacksburg, NE / 53515",
    "989 Vernice Flats Apt. 183 - Billings, NV / 04147",
    "91020 Wehner Locks Apt. 673 - Albany, WY / 68763",
    "585 Candelario Pass Suite 090 - Columbus, LA / 25376",
    "80988 Renner Crest Apt. 000 - Fargo, VA / 24266",
    "28307 Shayne Pike Suite 523 - North Las Vegas, AZ / 28550",
    "205 Farrell Highway Suite 333 - Rock Hill, OK / 63421",
    "253 Kara Motorway Suite 821 - Manchester, SD / 09331",
    "13663 Kiara Oval Suite 606 - Missoula, AR / 44478",
    "8110 Claire Port Apt. 703 - Anchorage, TN / 01753",
    "4642 Demetris Lane Suite 407 - Edmond, AZ / 60888",
    "74794 Asha Flat Suite 890 - Lancaster, OR / 13466",
    "8135 Keeling Pines Apt. 326 - Alexandria, MA / 89442",
    "441 Gibson Shores Suite 247 - Pasco, NM / 60678",
    "4373 Emelia Valley Suite 596 - Columbia, NM / 42586",
    "1946 Strosin Creek Apt. 279 - Casper, CO / 21335",
    "147 Rempel Center Apt. 305 - Centennial, TN / 09375",
    "78481 Floyd Mountains Apt. 184 - Glendale, SD / 18777",
    "129 Toy Pines Suite 339 - Idaho Falls, CT / 82070",
    "08945 Cremin Underpass Apt. 700 - Iowa City, GA / 33243",
    "20728 Dorcas Highway Suite 959 - Largo, ND / 99931",
    "492 Wilburn Park Apt. 746 - Bellevue, TN / 16077",
    "70530 Garfield Tunnel Suite 902 - Detroit, IA / 01664",
    "868 Kautzer Grove Suite 334 - Kearny, KS / 51368",
    "71189 Towne Forks Suite 519 - Anchorage, IL / 52636",
    "5070 Magdalena Neck Suite 096 - Cedar Rapids, PA / 01342",
    "6216 Jermain Walk Apt. 279 - Wilmington, MA / 55416",
    "1795 Kilback Stravenue Apt. 745 - Concord, MA / 96099",
    "831 Rolfson Expressway Apt. 878 - Norman, NY / 10239",
    "909 Nathaniel Lake Suite 769 - Sherman, NJ / 46523",
    "3690 Hans Ports Apt. 369 - Cary, KS / 48930"
];
var country = [
    "Kenya",
    "Madagascar",
    "Netherlands Antilles",
    "Azerbaijan",
    "Aruba",
    "Comoros",
    "Sierra Leone",
    "Bermuda",
    "Italy",
    "Iran",
    "Denmark",
    "Congo",
    "Cambodia",
    "Virgin Islands, British",
    "Bahamas",
    "Italy",
    "France",
    "Portugal",
    "Nepal",
    "Saint Vincent and the Grenadines",
    "Greenland",
    "Maldives",
    "Comoros",
    "Bhutan",
    "Tuvalu",
    "Ethiopia",
    "Myanmar",
    "Libyan Arab Jamahiriya",
    "Senegal",
    "Malta",
    "Kyrgyz Republic",
    "Turks and Caicos Islands",
    "Gibraltar",
    "Sweden",
    "Zambia",
    "Isle of Man",
    "Canada",
    "Turkey",
    "Samoa",
    "Vietnam"
];

;// CONCATENATED MODULE: ./src/_mock/name.ts
// ----------------------------------------------------------------------
var fullName = [
    "Jayvion Simon",
    "Lucian Obrien",
    "Deja Brady",
    "Harrison Stein",
    "Reece Chung",
    "Lainey Davidson",
    "Cristopher Cardenas",
    "Melanie Noble",
    "Chase Day",
    "Shawn Manning",
    "Soren Durham",
    "Cortez Herring",
    "Brycen Jimenez",
    "Giana Brandt",
    "Aspen Schmitt",
    "Colten Aguilar",
    "Angelique Morse",
    "Selina Boyer",
    "Lawson Bass",
    "Ariana Lang",
    "Amiah Pruitt",
    "Harold Mcgrath",
    "Esperanza Mcintyre",
    "Mireya Conner",
    "Jamie Kline",
    "Laney Vazquez",
    "Tiffany May",
    "Dexter Shepherd",
    "Jaqueline Spencer",
    "Londyn Jarvis",
    "Yesenia Butler",
    "Jayvon Hull",
    "Izayah Pope",
    "Ayana Hunter",
    "Isabell Bender",
    "Desiree Schmidt",
    "Aidan Stout",
    "Jace Bush",
    "Janiya Williamson",
    "Hudson Alvarez", 
];
var firstName = [
    "Mossie",
    "David",
    "Ebba",
    "Chester",
    "Eula",
    "Jaren",
    "Boyd",
    "Brady",
    "Aida",
    "Anastasia",
    "Gregoria",
    "Julianne",
    "Ila",
    "Elyssa",
    "Lucio",
    "Lewis",
    "Jacinthe",
    "Molly",
    "Brown",
    "Fritz",
    "Keon",
    "Ella",
    "Ken",
    "Whitney",
    "Monte",
    "Rose",
    "Shana",
    "Devon",
    "Jaleel",
    "Laury",
    "Brooks",
    "Bruce",
    "Avery",
    "Esperanza",
    "Helene",
    "Heloise",
    "Elinor",
    "Adeline",
    "Haley",
    "Anabelle", 
];
var lastName = [
    "Carroll",
    "Simonis",
    "Yost",
    "Hand",
    "Emmerich",
    "Wilderman",
    "Howell",
    "Sporer",
    "Boehm",
    "Morar",
    "Koch",
    "Reynolds",
    "Padberg",
    "Watsica",
    "Upton",
    "Yundt",
    "Pfeffer",
    "Parker",
    "Zulauf",
    "Treutel",
    "McDermott",
    "McDermott",
    "Cruickshank",
    "Parisian",
    "Auer",
    "Turner",
    "Dooley",
    "Wiegand",
    "Abbott",
    "Wisoky",
    "Fahey",
    "Satterfield",
    "Bahringer",
    "Schulist",
    "Durgan",
    "Carroll",
    "Jones",
    "Leffler",
    "Gutkowski",
    "Homenick", 
];

;// CONCATENATED MODULE: ./src/_mock/text.ts
// ----------------------------------------------------------------------
var title = [
    "Apply These 7 Secret Techniques To Improve Event",
    "Believing These 7 Myths About Event Keeps You From Growing",
    "Don't Waste Time! 7 Facts Until You Reach Your Event",
    "How 7 Things Will Change The Way You Approach Event",
    "Event Awards: 7 Reasons Why They Don't Work & What You Can Do About It",
    "Event Doesn't Have To Be Hard. Read These 7 Tips",
    "Event Is Your Worst Enemy. 7 Ways To Defeat It",
    "Event On A Budget: 7 Tips From The Great Depression",
    "Knowing These 7 Secrets Will Make Your Event Look Amazing",
    "Master The Art Of Event With These 7 Tips",
    "My Life, My Job, My Career: How 7 Simple Event Helped Me Succeed",
    "Take Advantage Of Event - Read These 7 Tips",
    "The Next 7 Things You Should Do For Event Success",
    "The Time Is Running Out! Think About These 7 Ways To Change Your Event",
    "The 7 Best Things About Event",
    "The 7 Biggest Event Mistakes You Can Easily Avoid",
    "The 7 Most Successful Event Companies In Region",
    "Think Your Event Is Safe? 7 Ways You Can Lose It Today",
    "Thinking About Event? 7 Reasons Why It's Time To Stop!",
    "7 Places To Get Deals On Event",
    "Best Event Android Apps",
    "Best Event Tips You Will Read This Year",
    "Best 30 Tips For Event",
    "Should Fixing Event Take 30 Steps?",
    "The A - Z Of Event",
    "The Next 30 Things To Immediately Do About Event",
    "The Ultimate Guide To Event",
    "Top 30 Funny Event Quotes",
    "Top 30 Quotes On Event",
    "Top 7 Lessons About Event To Learn Before You Hit 30",
    "Top 7 Ways To Buy A Used Event",
    "30 Best Ways To Sell Event",
    "30 Ideas For Event",
    "30 Lessons About Event You Need To Learn Before You Hit 40",
    "30 Methods Of Event Domination",
    "30 Things To Do Immediately About Event",
    "30 Tips To Grow Your Event",
    "30 Ways To Avoid Event Burnout",
    "30 Ways To Improve Event",
    "How To Make More Event By Doing Less"
];
var sentence = [
    "Assumenda nam repudiandae rerum fugiat vel maxime.",
    "Quis veniam aut saepe aliquid nulla.",
    "Reprehenderit ut voluptas sapiente ratione nostrum est.",
    "Error ut sit vel molestias velit.",
    "Quo quia sit nihil nemo doloremque et.",
    "Autem doloribus harum vero laborum.",
    "Tempora officiis consequuntur architecto nostrum autem nam adipisci.",
    "Voluptas sunt magni adipisci praesentium saepe.",
    "Ea architecto quas voluptates voluptas earum illo est vel rem.",
    "Ipsum expedita reiciendis ut.",
    "Architecto vel voluptatibus alias a aut non maxime ipsa voluptates.",
    "Reiciendis enim officiis cupiditate eaque distinctio laudantium modi similique consequatur.",
    "Ab autem consequatur itaque mollitia ipsum cupiditate error repudiandae nobis.",
    "Distinctio architecto debitis eligendi consequatur unde id modi accusantium possimus.",
    "At ut voluptate accusantium.",
    "Repudiandae ut qui veritatis sint.",
    "Laboriosam blanditiis quo sed et qui esse ipsam necessitatibus sed.",
    "Et molestiae et excepturi maxime omnis.",
    "Sint dolorem quam eum magnam.",
    "Rerum ut iusto iste quam voluptatem necessitatibus.",
    "Et quam in.",
    "Fugit esse tenetur.",
    "Dolorem dolor porro nihil cupiditate molestiae deserunt ut.",
    "Omnis beatae eos eius aut molestias laboriosam laborum et optio.",
    "Ut veniam quam assumenda ut voluptatibus ducimus accusamus.",
    "Quos dignissimos neque omnis reiciendis voluptatem ducimus.",
    "Laboriosam quia ut esse.",
    "Sit reiciendis nihil qui molestias et.",
    "Facilis cupiditate minima ratione quaerat omnis velit non ex totam.",
    "Provident sint esse voluptatem voluptas eveniet est.",
    "Molestias consequatur ea facilis.",
    "Tempora voluptatibus autem ut ut porro quae delectus dolorum.",
    "Et consequatur amet nemo ducimus voluptatem placeat voluptas.",
    "Modi iste atque hic voluptas sit quis deleniti quas consequatur.",
    "Omnis est aliquid odio mollitia aliquid ex.",
    "Officia possimus veniam quod molestias.",
    "Mollitia inventore recusandae provident aut.",
    "Numquam ullam beatae possimus.",
    "Fuga velit cupiditate ex culpa odio aut ut.",
    "Vero corrupti nam voluptatum excepturi est et."
];
var description = [
    "Occaecati est et illo quibusdam accusamus qui. Incidunt aut et molestiae ut facere aut. Est quidem iusto praesentium excepturi harum nihil tenetur facilis. Ut omnis voluptates nihil accusantium doloribus eaque debitis.",
    "Atque eaque ducimus minima distinctio velit. Laborum et veniam officiis. Delectus ex saepe hic id laboriosam officia. Odit nostrum qui illum saepe debitis ullam. Laudantium beatae modi fugit ut. Dolores consequatur beatae nihil voluptates rem maiores.",
    "Rerum eius velit dolores. Explicabo ad nemo quibusdam. Voluptatem eum suscipit et ipsum et consequatur aperiam quia. Rerum nulla sequi recusandae illum velit quia quas. Et error laborum maiores cupiditate occaecati.",
    "Et non omnis qui. Qui sunt deserunt dolorem aut velit cumque adipisci aut enim. Nihil quis quisquam nesciunt dicta nobis ab aperiam dolorem repellat. Voluptates non blanditiis. Error et tenetur iste soluta cupiditate ratione perspiciatis et. Quibusdam aliquid nam sunt et quisquam non esse.",
    "Nihil ea sunt facilis praesentium atque. Ab animi alias sequi molestias aut velit ea. Sed possimus eos. Et est aliquid est voluptatem.",
    "Non rerum modi. Accusamus voluptatem odit nihil in. Quidem et iusto numquam veniam culpa aperiam odio aut enim. Quae vel dolores. Pariatur est culpa veritatis aut dolorem.",
    "Est enim et sit non impedit aperiam cumque animi. Aut eius impedit saepe blanditiis. Totam molestias magnam minima fugiat.",
    "Unde a inventore et. Sed esse ut. Atque ducimus quibusdam fuga quas id qui fuga.",
    "Eaque natus adipisci soluta nostrum dolorem. Nesciunt ipsum molestias ut aliquid natus ut omnis qui fugiat. Dolor et rem. Ut neque voluptatem blanditiis quasi ullam deleniti.",
    "Nam et error exercitationem qui voluptate optio. Officia omnis qui accusantium ipsam qui. Quia sequi nulla perspiciatis optio vero omnis maxime omnis ipsum. Perspiciatis consequuntur asperiores veniam dolores.",
    "Perspiciatis nulla ut ut ut voluptates totam consectetur eligendi qui. Optio ut cum. Dolorum sapiente qui laborum. Impedit temporibus totam delectus nihil. Voluptatem corrupti rem.",
    "Distinctio omnis similique omnis eos. Repellat cumque rerum nisi. Reiciendis soluta non ut veniam temporibus. Accusantium et dolorem voluptas harum. Nemo eius voluptate dicta et hic nemo. Dolorem assumenda et beatae molestias sit quo mollitia quis consequatur.",
    "Sed ut mollitia tempore ipsam et illum doloribus ut. Occaecati ratione veritatis explicabo. Omnis nam omnis sunt placeat tempore accusantium placeat distinctio velit.",
    "Eum illo dicta et perspiciatis ut blanditiis eos sequi. Ea veritatis aut et voluptas aut. Laborum eos quia tempore a culpa.",
    "Aut quos quae dolores repudiandae similique perferendis perferendis earum laudantium. Facere placeat natus nobis. Eius vitae ullam dolorem.",
    "Vero dolorem et voluptatem fugit tempore a quam iure. Fuga consequatur corrupti sunt asperiores vitae. Libero totam repellendus animi debitis illum et sunt officia.",
    "Cupiditate illum officiis id molestiae. Numquam non molestiae aliquid et natus sed hic. Alias quia explicabo sed corrupti sint. Natus in et odio qui unde facilis quia. Est sit eius laboriosam aliquid non aperiam quia quo corporis.",
    "Et a ab. Optio aspernatur minus tempora amet vitae consectetur inventore cumque. Sed et omnis. Aspernatur a magnam.",
    "Ipsum omnis et. Quia ea et autem tempore consequuntur veniam dolorem officiis. Ipsa dicta et ut quidem quia doloremque. Sequi vitae doloremque temporibus. Deserunt incidunt id aperiam itaque natus. Earum sit eaque quas incidunt nihil.",
    "Quae consequatur reiciendis. Consequatur non optio. Eaque id placeat. Commodi quo officia aut repudiandae reiciendis tempore voluptatem et. Ut accusamus qui itaque maxime aliquam. Fugit ut animi molestiae porro maiores.",
    "Modi hic asperiores ab cumque quam est aut. Voluptas atque quos molestias. Ut excepturi distinctio ipsam aspernatur sit.",
    "Sunt totam facilis. Quam commodi voluptatem veniam. Tempora deleniti itaque fugit nihil voluptas.",
    "Ipsam aliquam velit nobis repellendus officiis aut deserunt id et. Nihil sunt aut dolores aut. Dolores est ipsa quia et laborum quidem laborum accusamus id. Facilis odit quod hic laudantium saepe omnis nisi in sint. Sed cupiditate possimus id.",
    "Magnam non eveniet optio optio ut aliquid atque. Velit libero aspernatur quis laborum consequatur laudantium. Tempora facere optio fugit accusantium ut. Omnis aspernatur reprehenderit autem esse ut ut enim voluptatibus.",
    "Ipsam vel molestiae dolorem iure molestiae. Ut qui cumque et sint recusandae modi nulla. Vel rerum tempore similique autem enim voluptatem dolores facilis. Qui delectus recusandae magnam.",
    "Fugiat molestias distinctio enim nobis rerum. Perspiciatis adipisci corrupti quas sed ab sunt nostrum. Quibusdam reiciendis ratione dolores vitae fuga exercitationem asperiores maxime voluptate. Minus et ea delectus quia ullam est. Exercitationem iusto libero. Et aut dolore reprehenderit et saepe sint modi.",
    "Ex neque aut voluptatem delectus eum deserunt voluptate. Ut quam placeat et. Et impedit tenetur illum aut consequatur quia. Autem sed dolorem non ad aspernatur illum dignissimos beatae. Earum iusto aut rem aut. Facere ea alias enim quo assumenda.",
    "Quis sint recusandae quasi corporis et fugit. Omnis voluptatum id laborum qui. Assumenda animi quia eum et facere fuga. Ab et sint molestiae et voluptatum nostrum est.",
    "Est quis numquam recusandae alias porro magni. Incidunt quis aut necessitatibus nam ea dolores cumque. Quis dolorum veniam.",
    "Corporis magnam non. Ut voluptates pariatur et. Quis tenetur mollitia et necessitatibus et. Perferendis error velit aut.",
    "Eos ex accusantium possimus aut quae. Omnis dolorum velit. Sapiente quia dolore ea assumenda voluptatem exercitationem sed consequuntur. Eveniet et molestiae ipsa harum quidem soluta quo. Consequatur ad sunt sed numquam odio eveniet.",
    "Ut sit et provident vero vero voluptatem distinctio. Cumque sit error qui et. Ea architecto ipsum occaecati sed alias eum vel. Officia tempore architecto autem vel veniam. Minus modi commodi ad consequatur similique ut. Tenetur tempore eum.",
    "Quibusdam in cum voluptatem consequatur rerum. Qui eum assumenda nemo maiores veniam quae. Ipsa occaecati et provident. Quas similique deserunt doloremque placeat natus.",
    "Voluptates et earum fugiat molestiae distinctio. Aut sapiente quas dolores et. Quo et dolor velit et iure consequatur ut in amet. Repellendus aut sequi animi inventore nesciunt itaque.",
    "Sit a tempore dicta provident molestiae. Necessitatibus blanditiis voluptatum. Magnam esse animi in qui veritatis quibusdam recusandae adipisci possimus. Tenetur dolores ipsum.",
    "Neque id sunt amet modi expedita aut libero aut in. Minima dolore praesentium quia quas et pariatur numquam. In ut sequi nemo velit iste minima aliquam. Neque ut tenetur consequuntur sint nemo unde. Magni nesciunt omnis illo optio. Molestias eum exercitationem aut harum odit.",
    "Modi quia laboriosam qui ad aut. Fugit quisquam earum distinctio officia est fugit quos. Iure repellat distinctio veritatis voluptate amet ratione repudiandae.",
    "Impedit perferendis vel quis ratione. Id aut id officia. Illum fuga saepe provident voluptate eligendi provident. Et nostrum maxime magni. Nobis cumque id magni in iste earum.",
    "Dolor numquam maiores praesentium dolorem nihil minus praesentium rem dolorem. Est rerum placeat. Numquam sed magni aliquam laborum enim facere ducimus.",
    "In sint enim nam et itaque et qui. Molestiae a iusto quidem quia temporibus id quia eaque eius. Quis quia consectetur saepe vero et molestias. Rem minima accusamus vitae adipisci molestiae unde voluptate consequatur molestiae. Rerum exercitationem quisquam vitae."
];

;// CONCATENATED MODULE: ./src/_mock/number.ts
// ----------------------------------------------------------------------
var price = [
    16.19,
    35.71,
    34.3,
    93.1,
    55.47,
    89.09,
    44.39,
    26.92,
    45.35,
    26.96,
    78.22,
    35.54,
    90.69,
    63.61,
    67.55,
    94.75,
    75.78,
    39.6,
    52.84,
    72.8,
    83.08,
    85.02,
    69.22,
    60.96,
    84.7,
    16.68,
    78.83,
    58.07,
    65.8,
    55.69,
    87.55,
    44.74,
    27.42,
    84,
    76.17,
    43.83,
    76.39,
    17.42,
    42.3,
    12.45
];
var rating = [
    2.5,
    2,
    4.9,
    2,
    4,
    5,
    4.9,
    5,
    3.7,
    2.5,
    2,
    4.9,
    4.8,
    4,
    2,
    3.7,
    1.4,
    2.4,
    1.8,
    5,
    2.9,
    3.9,
    3.9,
    1.8,
    5,
    2.6,
    3.1,
    3.9,
    1.2,
    3.2,
    4.1,
    5,
    4.5,
    4.1,
    2.3,
    2.4,
    5,
    3.1,
    4.9,
    1.7
];
var age = [
    52,
    43,
    56,
    25,
    22,
    53,
    38,
    50,
    55,
    37,
    16,
    27,
    55,
    41,
    52,
    32,
    34,
    52,
    31,
    53,
    23,
    48,
    43,
    41,
    19,
    21,
    17,
    29,
    32,
    54,
    38,
    34,
    49,
    33,
    55,
    50,
    24,
    27,
    23,
    23
];
var percent = [
    8.62,
    86.36,
    73.99,
    79,
    63.41,
    58.79,
    12.32,
    88.44,
    45.06,
    91.64,
    88.41,
    73.08,
    39.14,
    89.34,
    43.37,
    34.45,
    24.04,
    80.96,
    72.91,
    47.59,
    2.46,
    3.33,
    99.31,
    47.6,
    34.09,
    50.61,
    66.13,
    46.69,
    92.43,
    31.41,
    90.85,
    36.32,
    38.84,
    25.6,
    87.61,
    1.31,
    89.32,
    41.23,
    85.9,
    62.63
];

;// CONCATENATED MODULE: ./src/_mock/_mock.ts

//









// ----------------------------------------------------------------------
var _mock_mock = {
    id: function(index) {
        return "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b".concat(index + 1);
    },
    email: function(index) {
        return email[index];
    },
    phoneNumber: function(index) {
        return phoneNumber[index];
    },
    time: function(index) {
        return (0,sub/* default */.Z)(new Date(), {
            days: index,
            hours: index
        });
    },
    boolean: function(index) {
        return boolean_boolean[index];
    },
    role: function(index) {
        return role[index];
    },
    company: function(index) {
        return company[index];
    },
    address: {
        fullAddress: function(index) {
            return fullAddress[index];
        },
        country: function(index) {
            return country[index];
        }
    },
    name: {
        firstName: function(index) {
            return firstName[index];
        },
        lastName: function(index) {
            return lastName[index];
        },
        fullName: function(index) {
            return fullName[index];
        }
    },
    text: {
        title: function(index) {
            return title[index];
        },
        sentence: function(index) {
            return sentence[index];
        },
        description: function(index) {
            return description[index];
        }
    },
    number: {
        percent: function(index) {
            return percent[index];
        },
        rating: function(index) {
            return rating[index];
        },
        age: function(index) {
            return age[index];
        },
        price: function(index) {
            return price[index];
        }
    },
    image: {
        cover: function(index) {
            return "https://minimal-assets-api.vercel.app/assets/images/covers/cover_".concat(index + 1, ".jpg");
        },
        feed: function(index) {
            return "https://minimal-assets-api.vercel.app/assets/images/feeds/feed_".concat(index + 1, ".jpg");
        },
        product: function(index) {
            return "https://minimal-assets-api.vercel.app/assets/images/products/product_".concat(index + 1, ".jpg");
        },
        avatar: function(index) {
            return "https://minimal-assets-api.vercel.app/assets/images/avatars/avatar_".concat(index + 1, ".jpg");
        }
    }
};
/* harmony default export */ var src_mock_mock = (_mock_mock);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/no-case/dist.es2015/index.js + 1 modules
var dist_es2015 = __webpack_require__(1902);
;// CONCATENATED MODULE: ./src/_mock/funcs.ts
// ----------------------------------------------------------------------
function randomNumber(number) {
    return Math.floor(Math.random() * number) + 1;
}
function randomNumberRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
function randomInArray(array) {
    return array[Math.floor(Math.random() * array.length)];
}

;// CONCATENATED MODULE: ./src/_mock/_app.ts


// _mock


// ----------------------------------------------------------------------
var _appRelated = [
    "Chrome",
    "Drive",
    "Dropbox",
    "Evernote",
    "Github"
].map(function(appName, index) {
    return {
        id: src_mock_mock.id(index),
        name: appName,
        system: index === 2 && "Windows" || index === 4 && "Windows" || "Mac",
        price: index === 0 || index === 2 || index === 4 ? 0 : src_mock_mock.number.price(index),
        rating: src_mock_mock.number.rating(index),
        review: randomNumberRange(999, 99999),
        shortcut: "https://minimal-assets-api.vercel.app/assets/icons/ic_".concat((0,dist_es2015/* noCase */.B)(appName), ".svg")
    };
});
var _appInstalled = [
    "de",
    "en",
    "fr",
    "kr",
    "us"
].map(function(country, index) {
    return {
        id: src_mock_mock.id(index),
        name: [
            "Germany",
            "England",
            "France",
            "Korean",
            "USA"
        ][index],
        android: randomNumberRange(999, 99999),
        windows: randomNumberRange(999, 99999),
        apple: randomNumberRange(999, 99999),
        flag: "https://minimal-assets-api.vercel.app/assets/icons/ic_flag_".concat(country, ".svg")
    };
});
var _appAuthors = (0,_to_consumable_array/* default */.Z)(Array(3)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        name: src_mock_mock.name.fullName(index),
        avatar: src_mock_mock.image.avatar(index),
        favourite: randomNumberRange(9999, 19999)
    };
});
var _appInvoices = (0,_to_consumable_array/* default */.Z)(Array(5)).map(function(_, index) {
    return {
        id: "".concat(Date.now() + index),
        price: src_mock_mock.number.price(index),
        category: randomInArray([
            "Android",
            "Mac",
            "Windows"
        ]),
        status: randomInArray([
            "paid",
            "out_of_date",
            "in_progress"
        ])
    };
});
var _appFeatured = (0,_to_consumable_array/* default */.Z)(Array(3)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        title: [
            "Harry Potter and the Deathly Hallows - Part 2",
            "Disney Zombies 2",
            "Lightroom mobile - Koloro", 
        ][index],
        description: src_mock_mock.text.title(index),
        image: src_mock_mock.image.feed(index)
    };
});

;// CONCATENATED MODULE: ./src/_mock/_user.ts



// ----------------------------------------------------------------------
var _userAbout = {
    id: src_mock_mock.id(1),
    cover: src_mock_mock.image.cover(1),
    position: "UI Designer",
    follower: randomNumberRange(999, 99999),
    following: randomNumberRange(999, 99999),
    quote: "Tart I love sugar plum I love oat cake. Sweet roll caramels I love jujubes. Topping cake wafer..",
    country: src_mock_mock.address.country(1),
    email: src_mock_mock.email(1),
    company: src_mock_mock.company(1),
    school: src_mock_mock.company(2),
    role: "Manager",
    facebookLink: "https://www.facebook.com/caitlyn.kerluke",
    instagramLink: "https://www.instagram.com/caitlyn.kerluke",
    linkedinLink: "https://www.linkedin.com/in/caitlyn.kerluke",
    twitterLink: "https://www.twitter.com/caitlyn.kerluke"
};
var _userFollowers = (0,_to_consumable_array/* default */.Z)(Array(18)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        avatarUrl: src_mock_mock.image.avatar(index),
        name: src_mock_mock.name.fullName(index),
        country: src_mock_mock.address.country(index),
        isFollowed: src_mock_mock.boolean(index)
    };
});
var _userFriends = (0,_to_consumable_array/* default */.Z)(Array(18)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        avatarUrl: src_mock_mock.image.avatar(index),
        name: src_mock_mock.name.fullName(index),
        role: src_mock_mock.role(index)
    };
});
var _userGallery = (0,_to_consumable_array/* default */.Z)(Array(12)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        title: src_mock_mock.text.title(index),
        postAt: src_mock_mock.time(index),
        imageUrl: src_mock_mock.image.cover(index)
    };
});
var _userFeeds = (0,_to_consumable_array/* default */.Z)(Array(3)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        author: {
            id: src_mock_mock.id(8),
            avatarUrl: src_mock_mock.image.avatar(1),
            name: "Caitlyn Kerluke"
        },
        isLiked: true,
        createdAt: src_mock_mock.time(index),
        media: src_mock_mock.image.feed(index),
        message: src_mock_mock.text.sentence(index),
        personLikes: (0,_to_consumable_array/* default */.Z)(Array(36)).map(function(_, index) {
            return {
                name: src_mock_mock.name.fullName(index),
                avatarUrl: src_mock_mock.image.avatar(index + 2)
            };
        }),
        comments: index === 2 && [] || [
            {
                id: src_mock_mock.id(7),
                author: {
                    id: src_mock_mock.id(8),
                    avatarUrl: src_mock_mock.image.avatar(randomInArray([
                        2,
                        3,
                        4,
                        5,
                        6
                    ]) || 2),
                    name: src_mock_mock.name.fullName(index + 5)
                },
                createdAt: src_mock_mock.time(2),
                message: "Praesent venenatis metus at"
            },
            {
                id: src_mock_mock.id(9),
                author: {
                    id: src_mock_mock.id(10),
                    avatarUrl: src_mock_mock.image.avatar(randomInArray([
                        7,
                        8,
                        9,
                        10,
                        11
                    ]) || 7),
                    name: src_mock_mock.name.fullName(index + 6)
                },
                createdAt: src_mock_mock.time(3),
                message: "Etiam rhoncus. Nullam vel sem. Pellentesque libero tortor, tincidunt et, tincidunt eget, semper nec, quam. Sed lectus."
            }, 
        ]
    };
});
var _userCards = (0,_to_consumable_array/* default */.Z)(Array(24)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        avatarUrl: src_mock_mock.image.avatar(index),
        cover: src_mock_mock.image.cover(index),
        name: src_mock_mock.name.fullName(index),
        follower: randomNumberRange(999, 99999),
        following: randomNumberRange(999, 99999),
        totalPost: randomNumberRange(999, 99999),
        position: src_mock_mock.role(index)
    };
});
var _userPayment = (0,_to_consumable_array/* default */.Z)(Array(2)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        cardNumber: [
            "**** **** **** 1234",
            "**** **** **** 5678",
            "**** **** **** 7878"
        ][index],
        cardType: [
            "master_card",
            "visa",
            "master_card"
        ][index]
    };
});
var _userAddressBook = (0,_to_consumable_array/* default */.Z)(Array(4)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        name: src_mock_mock.name.fullName(index),
        phone: src_mock_mock.phoneNumber(index),
        country: src_mock_mock.address.country(index),
        state: "New Hampshire",
        city: "East Sambury",
        street: "41256 Kamille Turnpike",
        zipCode: "85807"
    };
});
var _userInvoices = (0,_to_consumable_array/* default */.Z)(Array(10)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        createdAt: src_mock_mock.time(index),
        price: src_mock_mock.number.price(index)
    };
});
var _userList = (0,_to_consumable_array/* default */.Z)(Array(24)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        avatarUrl: src_mock_mock.image.avatar(index),
        name: src_mock_mock.name.fullName(index),
        email: src_mock_mock.email(index),
        phoneNumber: src_mock_mock.phoneNumber(index),
        address: "908 Jack Locks",
        country: src_mock_mock.address.country(index),
        state: "Virginia",
        city: "Rancho Cordova",
        zipCode: "85807",
        company: src_mock_mock.company(index),
        isVerified: src_mock_mock.boolean(index),
        status: randomInArray([
            "active",
            "banned"
        ]),
        role: src_mock_mock.role(index)
    };
});

// EXTERNAL MODULE: ./src/assets/index.ts + 16 modules
var assets = __webpack_require__(50180);
;// CONCATENATED MODULE: ./src/_mock/_plans.tsx



// ----------------------------------------------------------------------
var LICENSES = [
    "Standard",
    "Standard Plus",
    "Extended"
];
var _homePlans = (0,_to_consumable_array/* default */.Z)(Array(3)).map(function(_, index) {
    return {
        license: LICENSES[index],
        commons: [
            "One end products",
            "12 months updates",
            "6 months of support"
        ],
        options: [
            "JavaScript version",
            "TypeScript version",
            "Design Resources",
            "Commercial applications", 
        ],
        icons: [
            "https://minimal-assets-api.vercel.app/assets/images/home/ic_sketch.svg",
            "https://minimal-assets-api.vercel.app/assets/images/home/ic_figma.svg",
            "https://minimal-assets-api.vercel.app/assets/images/home/ic_js.svg",
            "https://minimal-assets-api.vercel.app/assets/images/home/ic_ts.svg", 
        ]
    };
});
var _pricingPlans = [
    {
        subscription: "basic",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(assets/* PlanFreeIcon */.OC, {}),
        price: 0,
        caption: "forever",
        lists: [
            {
                text: "3 prototypes",
                isAvailable: true
            },
            {
                text: "3 boards",
                isAvailable: true
            },
            {
                text: "Up to 5 team members",
                isAvailable: false
            },
            {
                text: "Advanced security",
                isAvailable: false
            },
            {
                text: "Permissions & workflows",
                isAvailable: false
            }, 
        ],
        labelAction: "current plan"
    },
    {
        subscription: "starter",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(assets/* PlanStarterIcon */.Zk, {}),
        price: 4.99,
        caption: "saving $24 a year",
        lists: [
            {
                text: "3 prototypes",
                isAvailable: true
            },
            {
                text: "3 boards",
                isAvailable: true
            },
            {
                text: "Up to 5 team members",
                isAvailable: true
            },
            {
                text: "Advanced security",
                isAvailable: false
            },
            {
                text: "Permissions & workflows",
                isAvailable: false
            }, 
        ],
        labelAction: "choose starter"
    },
    {
        subscription: "premium",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(assets/* PlanPremiumIcon */.Ku, {}),
        price: 9.99,
        caption: "saving $124 a year",
        lists: [
            {
                text: "3 prototypes",
                isAvailable: true
            },
            {
                text: "3 boards",
                isAvailable: true
            },
            {
                text: "Up to 5 team members",
                isAvailable: true
            },
            {
                text: "Advanced security",
                isAvailable: true
            },
            {
                text: "Permissions & workflows",
                isAvailable: true
            }, 
        ],
        labelAction: "choose premium"
    }, 
];

;// CONCATENATED MODULE: ./src/_mock/_others.ts



// ----------------------------------------------------------------------
var _carouselsExample = (0,_to_consumable_array/* default */.Z)(Array(5)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        title: src_mock_mock.text.title(index),
        image: src_mock_mock.image.feed(index),
        description: src_mock_mock.text.description(index)
    };
});
var _carouselsMembers = (0,_to_consumable_array/* default */.Z)(Array(5)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        name: src_mock_mock.name.fullName(index),
        role: src_mock_mock.role(index),
        avatar: "https://minimal-assets-api.vercel.app/assets/images/members/member-".concat(index + 1, ".jpg")
    };
});
// ----------------------------------------------------------------------
var _invoice = {
    id: "".concat(Date.now()),
    taxes: 5,
    discount: 10,
    status: "paid",
    invoiceFrom: {
        name: src_mock_mock.name.fullName(1),
        address: src_mock_mock.address.fullAddress(1),
        company: src_mock_mock.company(1),
        email: src_mock_mock.email(1),
        phone: src_mock_mock.phoneNumber(1)
    },
    invoiceTo: {
        name: src_mock_mock.name.fullName(2),
        address: src_mock_mock.address.fullAddress(2),
        company: src_mock_mock.company(2),
        email: src_mock_mock.email(2),
        phone: src_mock_mock.phoneNumber(2)
    },
    items: (0,_to_consumable_array/* default */.Z)(Array(3)).map(function(_, index) {
        return {
            id: src_mock_mock.id(index),
            title: src_mock_mock.text.title(index),
            description: src_mock_mock.text.description(index),
            qty: 5,
            price: src_mock_mock.number.price(index)
        };
    })
};
// ----------------------------------------------------------------------
var _faqs = (0,_to_consumable_array/* default */.Z)(Array(8)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        value: "panel".concat(index + 1),
        heading: "Questions ".concat(index + 1),
        detail: src_mock_mock.text.description(index)
    };
});
// ----------------------------------------------------------------------
var _addressBooks = (0,_to_consumable_array/* default */.Z)(Array(5)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        receiver: src_mock_mock.name.fullName(index),
        fullAddress: src_mock_mock.address.fullAddress(index),
        phone: src_mock_mock.phoneNumber(index),
        addressType: index === 0 ? "Home" : "Office",
        isDefault: index === 0
    };
});
// ----------------------------------------------------------------------
var _skills = (0,_to_consumable_array/* default */.Z)(Array(3)).map(function(_, index) {
    return {
        label: [
            "Development",
            "Design",
            "Marketing"
        ][index],
        value: src_mock_mock.number.percent(index)
    };
});
// ----------------------------------------------------------------------
var _accordions = (0,_to_consumable_array/* default */.Z)(Array(4)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        value: "panel".concat(index + 1),
        heading: "Accordion ".concat(index + 1),
        subHeading: src_mock_mock.text.title(index),
        detail: src_mock_mock.text.description(index)
    };
});
// ----------------------------------------------------------------------
var _dataGrid = (0,_to_consumable_array/* default */.Z)(Array(36)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        name: src_mock_mock.name.fullName(index),
        email: src_mock_mock.email(index),
        lastLogin: src_mock_mock.time(index),
        performance: src_mock_mock.number.percent(index),
        rating: src_mock_mock.number.rating(index),
        status: randomInArray([
            "online",
            "away",
            "busy"
        ]),
        isAdmin: src_mock_mock.boolean(index),
        lastName: src_mock_mock.name.lastName(index),
        firstName: src_mock_mock.name.firstName(index),
        age: src_mock_mock.number.age(index)
    };
});
// ----------------------------------------------------------------------
var _megaMenuProducts = (0,_to_consumable_array/* default */.Z)(Array(10)).map(function(_, index) {
    return {
        name: src_mock_mock.text.title(index),
        image: src_mock_mock.image.feed(index),
        path: "#"
    };
});
// ----------------------------------------------------------------------
var _contacts = (0,_to_consumable_array/* default */.Z)(Array(20)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        name: src_mock_mock.name.fullName(index),
        username: src_mock_mock.name.fullName(index),
        avatar: src_mock_mock.image.avatar(index),
        address: src_mock_mock.address.fullAddress(index),
        phone: src_mock_mock.phoneNumber(index),
        email: src_mock_mock.email(index),
        lastActivity: src_mock_mock.time(index),
        status: randomInArray([
            "online",
            "offline",
            "away",
            "busy"
        ]),
        position: src_mock_mock.role(index)
    };
});
// ----------------------------------------------------------------------
var _notifications = (0,_to_consumable_array/* default */.Z)(Array(5)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        title: [
            "Your order is placed",
            "Sylvan King",
            "You have new message",
            "You have new mail",
            "Delivery processing", 
        ][index],
        description: [
            "waiting for shipping",
            "answered to your comment on the Minimal",
            "5 unread messages",
            "sent from Guido Padberg",
            "Your order is being shipped", 
        ][index],
        avatar: [
            null,
            src_mock_mock.image.avatar(2),
            null,
            null,
            null
        ][index],
        type: [
            "order_placed",
            "friend_interactive",
            "chat_message",
            "mail",
            "order_shipped"
        ][index],
        createdAt: src_mock_mock.time(index),
        isUnRead: [
            true,
            true,
            false,
            false,
            false
        ][index]
    };
});
// ----------------------------------------------------------------------
var _mapContact = [
    {
        latlng: [
            33,
            65
        ],
        address: src_mock_mock.address.fullAddress(1),
        phoneNumber: src_mock_mock.phoneNumber(1)
    },
    {
        latlng: [
            -12.5,
            18.5
        ],
        address: src_mock_mock.address.fullAddress(2),
        phoneNumber: src_mock_mock.phoneNumber(2)
    }, 
];

;// CONCATENATED MODULE: ./src/_mock/_booking.ts



// ----------------------------------------------------------------------
var _bookings = (0,_to_consumable_array/* default */.Z)(Array(5)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        name: src_mock_mock.name.fullName(index),
        avatar: src_mock_mock.image.avatar(index),
        checkIn: src_mock_mock.time(index),
        checkOut: src_mock_mock.time(index),
        phoneNumber: src_mock_mock.phoneNumber(index),
        status: randomInArray([
            "pending",
            "un_paid",
            "paid"
        ]),
        roomType: randomInArray([
            "double",
            "king",
            "single"
        ])
    };
});
var _bookingsOverview = (0,_to_consumable_array/* default */.Z)(Array(3)).map(function(_, index) {
    return {
        status: [
            "Pending",
            "Cancel",
            "Done"
        ][index],
        quantity: src_mock_mock.number.percent(index) * 1000,
        value: src_mock_mock.number.percent(index)
    };
});
var _bookingReview = (0,_to_consumable_array/* default */.Z)(Array(5)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        name: src_mock_mock.name.fullName(index),
        description: src_mock_mock.text.description(index),
        avatar: src_mock_mock.image.avatar(index),
        rating: src_mock_mock.number.rating(index),
        postedAt: src_mock_mock.time(index),
        tags: [
            "Great Sevice",
            "Recommended",
            "Best Price"
        ]
    };
});
var _bookingNew = (0,_to_consumable_array/* default */.Z)(Array(5)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        name: src_mock_mock.name.fullName(index),
        avatar: src_mock_mock.image.avatar(index),
        bookdAt: src_mock_mock.time(index),
        roomNumber: "A-21",
        roomType: randomInArray([
            "double",
            "king",
            "single"
        ]),
        person: "3-5",
        cover: "https://minimal-assets-api.vercel.app/assets/images/rooms/room-".concat(index + 1, ".jpg")
    };
});

;// CONCATENATED MODULE: ./src/_mock/_banking.ts


// ----------------------------------------------------------------------
var _bankingContacts = (0,_to_consumable_array/* default */.Z)(Array(5)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        name: src_mock_mock.name.fullName(index),
        email: src_mock_mock.email(index),
        avatar: src_mock_mock.image.avatar(index + 4)
    };
});
var _bankingQuickTransfer = (0,_to_consumable_array/* default */.Z)(Array(12)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        name: src_mock_mock.name.fullName(index),
        email: src_mock_mock.email(index),
        avatar: src_mock_mock.image.avatar(index)
    };
});
var _bankingCreditCard = [
    {
        id: src_mock_mock.id(2),
        balance: 23432.03,
        cardType: "mastercard",
        cardHolder: src_mock_mock.name.fullName(2),
        cardNumber: "**** **** **** 3640",
        cardValid: "11/22"
    },
    {
        id: src_mock_mock.id(3),
        balance: 18000.23,
        cardType: "visa",
        cardHolder: src_mock_mock.name.fullName(3),
        cardNumber: "**** **** **** 8864",
        cardValid: "11/25"
    },
    {
        id: src_mock_mock.id(4),
        balance: 2000.89,
        cardType: "mastercard",
        cardHolder: src_mock_mock.name.fullName(4),
        cardNumber: "**** **** **** 7755",
        cardValid: "11/22"
    }, 
];
var _bankingRecentTransitions = [
    {
        id: src_mock_mock.id(2),
        name: src_mock_mock.name.fullName(2),
        avatar: src_mock_mock.image.avatar(8),
        type: "Income",
        message: "Receive money from",
        category: "Annette Black",
        date: 1627556358365,
        status: "in_progress",
        amount: 811.45
    },
    {
        id: src_mock_mock.id(3),
        name: src_mock_mock.name.fullName(3),
        avatar: src_mock_mock.image.avatar(9),
        type: "Expenses",
        message: "Payment for",
        category: "Courtney Henry",
        date: 1627556329038,
        status: "completed",
        amount: 436.03
    },
    {
        id: src_mock_mock.id(4),
        name: src_mock_mock.name.fullName(4),
        avatar: src_mock_mock.image.avatar(12),
        type: "Receive",
        message: "Payment for",
        category: "Theresa Webb",
        date: 1627556339677,
        status: "failed",
        amount: 82.26
    },
    {
        id: src_mock_mock.id(5),
        name: null,
        avatar: null,
        type: "Expenses",
        message: "Payment for",
        category: "Beauty & Health",
        date: 1627547330510,
        status: "completed",
        amount: 480.73
    },
    {
        id: src_mock_mock.id(6),
        name: null,
        avatar: null,
        type: "Expenses",
        message: "Payment for",
        category: "Books",
        date: 1627556347676,
        status: "in_progress",
        amount: 11.45
    }, 
];

;// CONCATENATED MODULE: ./src/_mock/_ecommerce.ts


// ----------------------------------------------------------------------
var COUNTRY = [
    "de",
    "en",
    "fr",
    "kr",
    "us"
];
var CATEGORY = [
    "CAP",
    "Branded Shoes",
    "Headphone",
    "Cell Phone",
    "Earings"
];
var PRODUCT_NAME = [
    "Small Granite Computer",
    "Small Rubber Mouse",
    "Awesome Rubber Hat",
    "Sleek Cotton Sausages",
    "Rustic Wooden Chicken", 
];
var _ecommerceSalesOverview = (0,_to_consumable_array/* default */.Z)(Array(3)).map(function(_, index) {
    return {
        label: [
            "Total Profit",
            "Total Income",
            "Total Expenses"
        ][index],
        amount: src_mock_mock.number.price(index) * 100,
        value: src_mock_mock.number.percent(index)
    };
});
var _ecommerceBestSalesman = (0,_to_consumable_array/* default */.Z)(Array(5)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        name: src_mock_mock.name.fullName(index),
        email: src_mock_mock.email(index),
        avatar: src_mock_mock.image.avatar(index + 8),
        category: CATEGORY[index],
        flag: "https://minimal-assets-api.vercel.app/assets/icons/ic_flag_".concat(COUNTRY[index], ".svg"),
        total: src_mock_mock.number.price(index),
        rank: "Top ".concat(index + 1)
    };
});
var _ecommerceLatestProducts = (0,_to_consumable_array/* default */.Z)(Array(5)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        name: PRODUCT_NAME[index],
        image: src_mock_mock.image.product(index),
        price: src_mock_mock.number.price(index),
        priceSale: index === 0 || index === 3 ? 0 : src_mock_mock.number.price(index),
        colors: index === 0 && [
            "#2EC4B6",
            "#E71D36",
            "#FF9F1C",
            "#011627"
        ] || index === 1 && [
            "#92140C",
            "#FFCF99"
        ] || index === 2 && [
            "#0CECDD",
            "#FFF338",
            "#FF67E7",
            "#C400FF",
            "#52006A",
            "#046582"
        ] || index === 3 && [
            "#845EC2",
            "#E4007C",
            "#2A1A5E"
        ] || [
            "#090088"
        ]
    };
});
var _ecommerceNewProducts = (0,_to_consumable_array/* default */.Z)(Array(5)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        name: [
            "Nike Air Max 97",
            "Nike Zoom Gravity",
            "Nike DBreak-Type",
            "Kyrie Flytrap 3 EP Basketball Shoe",
            "Nike Air Max Fusion Men", 
        ][index],
        image: src_mock_mock.image.product(index)
    };
});

;// CONCATENATED MODULE: ./src/_mock/_analytics.tsx
// components



//

// ----------------------------------------------------------------------
var _analyticPost = (0,_to_consumable_array/* default */.Z)(Array(5)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        title: src_mock_mock.text.title(index),
        description: src_mock_mock.text.description(index),
        image: src_mock_mock.image.cover(index),
        postedAt: src_mock_mock.time(index)
    };
});
var _analyticOrderTimeline = (0,_to_consumable_array/* default */.Z)(Array(5)).map(function(_, index) {
    return {
        id: src_mock_mock.id(index),
        title: [
            "1983, orders, $4220",
            "12 Invoices have been paid",
            "Order #37745 from September",
            "New order placed #XF-2356",
            "New order placed #XF-2346", 
        ][index],
        type: "order".concat(index + 1),
        time: src_mock_mock.time(index)
    };
});
var _analyticTraffic = [
    {
        name: "FaceBook",
        value: 323234,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
            icon: "eva:facebook-fill",
            color: "#1877F2",
            width: 32,
            height: 32
        })
    },
    {
        name: "Google",
        value: 341212,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
            icon: "eva:google-fill",
            color: "#DF3E30",
            width: 32,
            height: 32
        })
    },
    {
        name: "Linkedin",
        value: 411213,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
            icon: "eva:linkedin-fill",
            color: "#006097",
            width: 32,
            height: 32
        })
    },
    {
        name: "Twitter",
        value: 443232,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
            icon: "eva:twitter-fill",
            color: "#1C9CEA",
            width: 32,
            height: 32
        })
    }, 
];

;// CONCATENATED MODULE: ./src/_mock/_countries.ts
var countries = [
    {
        code: "AD",
        label: "Andorra",
        phone: "376"
    },
    {
        code: "AE",
        label: "United Arab Emirates",
        phone: "971"
    },
    {
        code: "AF",
        label: "Afghanistan",
        phone: "93"
    },
    {
        code: "AG",
        label: "Antigua and Barbuda",
        phone: "1-268"
    },
    {
        code: "AI",
        label: "Anguilla",
        phone: "1-264"
    },
    {
        code: "AL",
        label: "Albania",
        phone: "355"
    },
    {
        code: "AM",
        label: "Armenia",
        phone: "374"
    },
    {
        code: "AO",
        label: "Angola",
        phone: "244"
    },
    {
        code: "AQ",
        label: "Antarctica",
        phone: "672"
    },
    {
        code: "AR",
        label: "Argentina",
        phone: "54"
    },
    {
        code: "AS",
        label: "American Samoa",
        phone: "1-684"
    },
    {
        code: "AT",
        label: "Austria",
        phone: "43"
    },
    {
        code: "AU",
        label: "Australia",
        phone: "61"
    },
    {
        code: "AW",
        label: "Aruba",
        phone: "297"
    },
    {
        code: "AX",
        label: "Alland Islands",
        phone: "358"
    },
    {
        code: "AZ",
        label: "Azerbaijan",
        phone: "994"
    },
    {
        code: "BA",
        label: "Bosnia and Herzegovina",
        phone: "387"
    },
    {
        code: "BB",
        label: "Barbados",
        phone: "1-246"
    },
    {
        code: "BD",
        label: "Bangladesh",
        phone: "880"
    },
    {
        code: "BE",
        label: "Belgium",
        phone: "32"
    },
    {
        code: "BF",
        label: "Burkina Faso",
        phone: "226"
    },
    {
        code: "BG",
        label: "Bulgaria",
        phone: "359"
    },
    {
        code: "BH",
        label: "Bahrain",
        phone: "973"
    },
    {
        code: "BI",
        label: "Burundi",
        phone: "257"
    },
    {
        code: "BJ",
        label: "Benin",
        phone: "229"
    },
    {
        code: "BL",
        label: "Saint Barthelemy",
        phone: "590"
    },
    {
        code: "BM",
        label: "Bermuda",
        phone: "1-441"
    },
    {
        code: "BN",
        label: "Brunei Darussalam",
        phone: "673"
    },
    {
        code: "BO",
        label: "Bolivia",
        phone: "591"
    },
    {
        code: "BR",
        label: "Brazil",
        phone: "55"
    },
    {
        code: "BS",
        label: "Bahamas",
        phone: "1-242"
    },
    {
        code: "BT",
        label: "Bhutan",
        phone: "975"
    },
    {
        code: "BV",
        label: "Bouvet Island",
        phone: "47"
    },
    {
        code: "BW",
        label: "Botswana",
        phone: "267"
    },
    {
        code: "BY",
        label: "Belarus",
        phone: "375"
    },
    {
        code: "BZ",
        label: "Belize",
        phone: "501"
    },
    {
        code: "CA",
        label: "Canada",
        phone: "1"
    },
    {
        code: "CC",
        label: "Cocos (Keeling) Islands",
        phone: "61"
    },
    {
        code: "CD",
        label: "Congo, Democratic Republic of the",
        phone: "243"
    },
    {
        code: "CF",
        label: "Central African Republic",
        phone: "236"
    },
    {
        code: "CG",
        label: "Congo, Republic of the",
        phone: "242"
    },
    {
        code: "CH",
        label: "Switzerland",
        phone: "41"
    },
    {
        code: "CI",
        label: "Cote d'Ivoire",
        phone: "225"
    },
    {
        code: "CK",
        label: "Cook Islands",
        phone: "682"
    },
    {
        code: "CL",
        label: "Chile",
        phone: "56"
    },
    {
        code: "CM",
        label: "Cameroon",
        phone: "237"
    },
    {
        code: "CN",
        label: "China",
        phone: "86"
    },
    {
        code: "CO",
        label: "Colombia",
        phone: "57"
    },
    {
        code: "CR",
        label: "Costa Rica",
        phone: "506"
    },
    {
        code: "CU",
        label: "Cuba",
        phone: "53"
    },
    {
        code: "CV",
        label: "Cape Verde",
        phone: "238"
    },
    {
        code: "CW",
        label: "Curacao",
        phone: "599"
    },
    {
        code: "CX",
        label: "Christmas Island",
        phone: "61"
    },
    {
        code: "CY",
        label: "Cyprus",
        phone: "357"
    },
    {
        code: "CZ",
        label: "Czech Republic",
        phone: "420"
    },
    {
        code: "DE",
        label: "Germany",
        phone: "49"
    },
    {
        code: "DJ",
        label: "Djibouti",
        phone: "253"
    },
    {
        code: "DK",
        label: "Denmark",
        phone: "45"
    },
    {
        code: "DM",
        label: "Dominica",
        phone: "1-767"
    },
    {
        code: "DO",
        label: "Dominican Republic",
        phone: "1-809"
    },
    {
        code: "DZ",
        label: "Algeria",
        phone: "213"
    },
    {
        code: "EC",
        label: "Ecuador",
        phone: "593"
    },
    {
        code: "EE",
        label: "Estonia",
        phone: "372"
    },
    {
        code: "EG",
        label: "Egypt",
        phone: "20"
    },
    {
        code: "EH",
        label: "Western Sahara",
        phone: "212"
    },
    {
        code: "ER",
        label: "Eritrea",
        phone: "291"
    },
    {
        code: "ES",
        label: "Spain",
        phone: "34"
    },
    {
        code: "ET",
        label: "Ethiopia",
        phone: "251"
    },
    {
        code: "FI",
        label: "Finland",
        phone: "358"
    },
    {
        code: "FJ",
        label: "Fiji",
        phone: "679"
    },
    {
        code: "FK",
        label: "Falkland Islands (Malvinas)",
        phone: "500"
    },
    {
        code: "FM",
        label: "Micronesia, Federated States of",
        phone: "691"
    },
    {
        code: "FO",
        label: "Faroe Islands",
        phone: "298"
    },
    {
        code: "FR",
        label: "France",
        phone: "33"
    },
    {
        code: "GA",
        label: "Gabon",
        phone: "241"
    },
    {
        code: "GB",
        label: "United Kingdom",
        phone: "44"
    },
    {
        code: "GD",
        label: "Grenada",
        phone: "1-473"
    },
    {
        code: "GE",
        label: "Georgia",
        phone: "995"
    },
    {
        code: "GF",
        label: "French Guiana",
        phone: "594"
    },
    {
        code: "GG",
        label: "Guernsey",
        phone: "44"
    },
    {
        code: "GH",
        label: "Ghana",
        phone: "233"
    },
    {
        code: "GI",
        label: "Gibraltar",
        phone: "350"
    },
    {
        code: "GL",
        label: "Greenland",
        phone: "299"
    },
    {
        code: "GM",
        label: "Gambia",
        phone: "220"
    },
    {
        code: "GN",
        label: "Guinea",
        phone: "224"
    },
    {
        code: "GP",
        label: "Guadeloupe",
        phone: "590"
    },
    {
        code: "GQ",
        label: "Equatorial Guinea",
        phone: "240"
    },
    {
        code: "GR",
        label: "Greece",
        phone: "30"
    },
    {
        code: "GS",
        label: "South Georgia and the South Sandwich Islands",
        phone: "500"
    },
    {
        code: "GT",
        label: "Guatemala",
        phone: "502"
    },
    {
        code: "GU",
        label: "Guam",
        phone: "1-671"
    },
    {
        code: "GW",
        label: "Guinea-Bissau",
        phone: "245"
    },
    {
        code: "GY",
        label: "Guyana",
        phone: "592"
    },
    {
        code: "HK",
        label: "Hong Kong",
        phone: "852"
    },
    {
        code: "HM",
        label: "Heard Island and McDonald Islands",
        phone: "672"
    },
    {
        code: "HN",
        label: "Honduras",
        phone: "504"
    },
    {
        code: "HR",
        label: "Croatia",
        phone: "385"
    },
    {
        code: "HT",
        label: "Haiti",
        phone: "509"
    },
    {
        code: "HU",
        label: "Hungary",
        phone: "36"
    },
    {
        code: "ID",
        label: "Indonesia",
        phone: "62"
    },
    {
        code: "IE",
        label: "Ireland",
        phone: "353"
    },
    {
        code: "IL",
        label: "Israel",
        phone: "972"
    },
    {
        code: "IM",
        label: "Isle of Man",
        phone: "44"
    },
    {
        code: "IN",
        label: "India",
        phone: "91"
    },
    {
        code: "IO",
        label: "British Indian Ocean Territory",
        phone: "246"
    },
    {
        code: "IQ",
        label: "Iraq",
        phone: "964"
    },
    {
        code: "IR",
        label: "Iran, Islamic Republic of",
        phone: "98"
    },
    {
        code: "IS",
        label: "Iceland",
        phone: "354"
    },
    {
        code: "IT",
        label: "Italy",
        phone: "39"
    },
    {
        code: "JE",
        label: "Jersey",
        phone: "44"
    },
    {
        code: "JM",
        label: "Jamaica",
        phone: "1-876"
    },
    {
        code: "JO",
        label: "Jordan",
        phone: "962"
    },
    {
        code: "JP",
        label: "Japan",
        phone: "81"
    },
    {
        code: "KE",
        label: "Kenya",
        phone: "254"
    },
    {
        code: "KG",
        label: "Kyrgyzstan",
        phone: "996"
    },
    {
        code: "KH",
        label: "Cambodia",
        phone: "855"
    },
    {
        code: "KI",
        label: "Kiribati",
        phone: "686"
    },
    {
        code: "KM",
        label: "Comoros",
        phone: "269"
    },
    {
        code: "KN",
        label: "Saint Kitts and Nevis",
        phone: "1-869"
    },
    {
        code: "KP",
        label: "Korea, Democratic People's Republic of",
        phone: "850"
    },
    {
        code: "KR",
        label: "Korea, Republic of",
        phone: "82"
    },
    {
        code: "KW",
        label: "Kuwait",
        phone: "965"
    },
    {
        code: "KY",
        label: "Cayman Islands",
        phone: "1-345"
    },
    {
        code: "KZ",
        label: "Kazakhstan",
        phone: "7"
    },
    {
        code: "LA",
        label: "Lao People's Democratic Republic",
        phone: "856"
    },
    {
        code: "LB",
        label: "Lebanon",
        phone: "961"
    },
    {
        code: "LC",
        label: "Saint Lucia",
        phone: "1-758"
    },
    {
        code: "LI",
        label: "Liechtenstein",
        phone: "423"
    },
    {
        code: "LK",
        label: "Sri Lanka",
        phone: "94"
    },
    {
        code: "LR",
        label: "Liberia",
        phone: "231"
    },
    {
        code: "LS",
        label: "Lesotho",
        phone: "266"
    },
    {
        code: "LT",
        label: "Lithuania",
        phone: "370"
    },
    {
        code: "LU",
        label: "Luxembourg",
        phone: "352"
    },
    {
        code: "LV",
        label: "Latvia",
        phone: "371"
    },
    {
        code: "LY",
        label: "Libya",
        phone: "218"
    },
    {
        code: "MA",
        label: "Morocco",
        phone: "212"
    },
    {
        code: "MC",
        label: "Monaco",
        phone: "377"
    },
    {
        code: "MD",
        label: "Moldova, Republic of",
        phone: "373"
    },
    {
        code: "ME",
        label: "Montenegro",
        phone: "382"
    },
    {
        code: "MF",
        label: "Saint Martin (French part)",
        phone: "590"
    },
    {
        code: "MG",
        label: "Madagascar",
        phone: "261"
    },
    {
        code: "MH",
        label: "Marshall Islands",
        phone: "692"
    },
    {
        code: "MK",
        label: "Macedonia, the Former Yugoslav Republic of",
        phone: "389"
    },
    {
        code: "ML",
        label: "Mali",
        phone: "223"
    },
    {
        code: "MM",
        label: "Myanmar",
        phone: "95"
    },
    {
        code: "MN",
        label: "Mongolia",
        phone: "976"
    },
    {
        code: "MO",
        label: "Macao",
        phone: "853"
    },
    {
        code: "MP",
        label: "Northern Mariana Islands",
        phone: "1-670"
    },
    {
        code: "MQ",
        label: "Martinique",
        phone: "596"
    },
    {
        code: "MR",
        label: "Mauritania",
        phone: "222"
    },
    {
        code: "MS",
        label: "Montserrat",
        phone: "1-664"
    },
    {
        code: "MT",
        label: "Malta",
        phone: "356"
    },
    {
        code: "MU",
        label: "Mauritius",
        phone: "230"
    },
    {
        code: "MV",
        label: "Maldives",
        phone: "960"
    },
    {
        code: "MW",
        label: "Malawi",
        phone: "265"
    },
    {
        code: "MX",
        label: "Mexico",
        phone: "52"
    },
    {
        code: "MY",
        label: "Malaysia",
        phone: "60"
    },
    {
        code: "MZ",
        label: "Mozambique",
        phone: "258"
    },
    {
        code: "NA",
        label: "Namibia",
        phone: "264"
    },
    {
        code: "NC",
        label: "New Caledonia",
        phone: "687"
    },
    {
        code: "NE",
        label: "Niger",
        phone: "227"
    },
    {
        code: "NF",
        label: "Norfolk Island",
        phone: "672"
    },
    {
        code: "NG",
        label: "Nigeria",
        phone: "234"
    },
    {
        code: "NI",
        label: "Nicaragua",
        phone: "505"
    },
    {
        code: "NL",
        label: "Netherlands",
        phone: "31"
    },
    {
        code: "NO",
        label: "Norway",
        phone: "47"
    },
    {
        code: "NP",
        label: "Nepal",
        phone: "977"
    },
    {
        code: "NR",
        label: "Nauru",
        phone: "674"
    },
    {
        code: "NU",
        label: "Niue",
        phone: "683"
    },
    {
        code: "NZ",
        label: "New Zealand",
        phone: "64"
    },
    {
        code: "OM",
        label: "Oman",
        phone: "968"
    },
    {
        code: "PA",
        label: "Panama",
        phone: "507"
    },
    {
        code: "PE",
        label: "Peru",
        phone: "51"
    },
    {
        code: "PF",
        label: "French Polynesia",
        phone: "689"
    },
    {
        code: "PG",
        label: "Papua New Guinea",
        phone: "675"
    },
    {
        code: "PH",
        label: "Philippines",
        phone: "63"
    },
    {
        code: "PK",
        label: "Pakistan",
        phone: "92"
    },
    {
        code: "PL",
        label: "Poland",
        phone: "48"
    },
    {
        code: "PM",
        label: "Saint Pierre and Miquelon",
        phone: "508"
    },
    {
        code: "PN",
        label: "Pitcairn",
        phone: "870"
    },
    {
        code: "PR",
        label: "Puerto Rico",
        phone: "1"
    },
    {
        code: "PS",
        label: "Palestine, State of",
        phone: "970"
    },
    {
        code: "PT",
        label: "Portugal",
        phone: "351"
    },
    {
        code: "PW",
        label: "Palau",
        phone: "680"
    },
    {
        code: "PY",
        label: "Paraguay",
        phone: "595"
    },
    {
        code: "QA",
        label: "Qatar",
        phone: "974"
    },
    {
        code: "RE",
        label: "Reunion",
        phone: "262"
    },
    {
        code: "RO",
        label: "Romania",
        phone: "40"
    },
    {
        code: "RS",
        label: "Serbia",
        phone: "381"
    },
    {
        code: "RU",
        label: "Russian Federation",
        phone: "7"
    },
    {
        code: "RW",
        label: "Rwanda",
        phone: "250"
    },
    {
        code: "SA",
        label: "Saudi Arabia",
        phone: "966"
    },
    {
        code: "SB",
        label: "Solomon Islands",
        phone: "677"
    },
    {
        code: "SC",
        label: "Seychelles",
        phone: "248"
    },
    {
        code: "SD",
        label: "Sudan",
        phone: "249"
    },
    {
        code: "SE",
        label: "Sweden",
        phone: "46"
    },
    {
        code: "SG",
        label: "Singapore",
        phone: "65"
    },
    {
        code: "SH",
        label: "Saint Helena",
        phone: "290"
    },
    {
        code: "SI",
        label: "Slovenia",
        phone: "386"
    },
    {
        code: "SJ",
        label: "Svalbard and Jan Mayen",
        phone: "47"
    },
    {
        code: "SK",
        label: "Slovakia",
        phone: "421"
    },
    {
        code: "SL",
        label: "Sierra Leone",
        phone: "232"
    },
    {
        code: "SM",
        label: "San Marino",
        phone: "378"
    },
    {
        code: "SN",
        label: "Senegal",
        phone: "221"
    },
    {
        code: "SO",
        label: "Somalia",
        phone: "252"
    },
    {
        code: "SR",
        label: "Suriname",
        phone: "597"
    },
    {
        code: "SS",
        label: "South Sudan",
        phone: "211"
    },
    {
        code: "ST",
        label: "Sao Tome and Principe",
        phone: "239"
    },
    {
        code: "SV",
        label: "El Salvador",
        phone: "503"
    },
    {
        code: "SX",
        label: "Sint Maarten (Dutch part)",
        phone: "1-721"
    },
    {
        code: "SY",
        label: "Syrian Arab Republic",
        phone: "963"
    },
    {
        code: "SZ",
        label: "Swaziland",
        phone: "268"
    },
    {
        code: "TC",
        label: "Turks and Caicos Islands",
        phone: "1-649"
    },
    {
        code: "TD",
        label: "Chad",
        phone: "235"
    },
    {
        code: "TF",
        label: "French Southern Territories",
        phone: "262"
    },
    {
        code: "TG",
        label: "Togo",
        phone: "228"
    },
    {
        code: "TH",
        label: "Thailand",
        phone: "66"
    },
    {
        code: "TJ",
        label: "Tajikistan",
        phone: "992"
    },
    {
        code: "TK",
        label: "Tokelau",
        phone: "690"
    },
    {
        code: "TL",
        label: "Timor-Leste",
        phone: "670"
    },
    {
        code: "TM",
        label: "Turkmenistan",
        phone: "993"
    },
    {
        code: "TN",
        label: "Tunisia",
        phone: "216"
    },
    {
        code: "TO",
        label: "Tonga",
        phone: "676"
    },
    {
        code: "TR",
        label: "Turkey",
        phone: "90"
    },
    {
        code: "TT",
        label: "Trinidad and Tobago",
        phone: "1-868"
    },
    {
        code: "TV",
        label: "Tuvalu",
        phone: "688"
    },
    {
        code: "TW",
        label: "Taiwan, Province of China",
        phone: "886"
    },
    {
        code: "TZ",
        label: "United Republic of Tanzania",
        phone: "255"
    },
    {
        code: "UA",
        label: "Ukraine",
        phone: "380"
    },
    {
        code: "UG",
        label: "Uganda",
        phone: "256"
    },
    {
        code: "US",
        label: "United States",
        phone: "1"
    },
    {
        code: "UY",
        label: "Uruguay",
        phone: "598"
    },
    {
        code: "UZ",
        label: "Uzbekistan",
        phone: "998"
    },
    {
        code: "VA",
        label: "Holy See (Vatican City State)",
        phone: "379"
    },
    {
        code: "VC",
        label: "Saint Vincent and the Grenadines",
        phone: "1-784"
    },
    {
        code: "VE",
        label: "Venezuela",
        phone: "58"
    },
    {
        code: "VG",
        label: "British Virgin Islands",
        phone: "1-284"
    },
    {
        code: "VI",
        label: "US Virgin Islands",
        phone: "1-340"
    },
    {
        code: "VN",
        label: "Vietnam",
        phone: "84"
    },
    {
        code: "VU",
        label: "Vanuatu",
        phone: "678"
    },
    {
        code: "WF",
        label: "Wallis and Futuna",
        phone: "681"
    },
    {
        code: "WS",
        label: "Samoa",
        phone: "685"
    },
    {
        code: "XK",
        label: "Kosovo",
        phone: "383"
    },
    {
        code: "YE",
        label: "Yemen",
        phone: "967"
    },
    {
        code: "YT",
        label: "Mayotte",
        phone: "262"
    },
    {
        code: "ZA",
        label: "South Africa",
        phone: "27"
    },
    {
        code: "ZM",
        label: "Zambia",
        phone: "260"
    },
    {
        code: "ZW",
        label: "Zimbabwe",
        phone: "263"
    }, 
];

;// CONCATENATED MODULE: ./src/_mock/_top100Films.ts
var top100Films = [
    {
        title: "The Shawshank Redemption",
        year: 1994
    },
    {
        title: "The Godfather",
        year: 1972
    },
    {
        title: "The Godfather: Part II",
        year: 1974
    },
    {
        title: "The Dark Knight",
        year: 2008
    },
    {
        title: "12 Angry Men",
        year: 1957
    },
    {
        title: "Schindler's List",
        year: 1993
    },
    {
        title: "Pulp Fiction",
        year: 1994
    },
    {
        title: "The Lord of the Rings: The Return of the King",
        year: 2003
    },
    {
        title: "The Good, the Bad and the Ugly",
        year: 1966
    },
    {
        title: "Fight Club",
        year: 1999
    },
    {
        title: "The Lord of the Rings: The Fellowship of the Ring",
        year: 2001
    },
    {
        title: "Star Wars: Episode V - The Empire Strikes Back",
        year: 1980
    },
    {
        title: "Forrest Gump",
        year: 1994
    },
    {
        title: "Inception",
        year: 2010
    },
    {
        title: "The Lord of the Rings: The Two Towers",
        year: 2002
    },
    {
        title: "One Flew Over the Cuckoo's Nest",
        year: 1975
    },
    {
        title: "Goodfellas",
        year: 1990
    },
    {
        title: "The Matrix",
        year: 1999
    },
    {
        title: "Seven Samurai",
        year: 1954
    },
    {
        title: "Star Wars: Episode IV - A New Hope",
        year: 1977
    },
    {
        title: "City of God",
        year: 2002
    },
    {
        title: "Se7en",
        year: 1995
    },
    {
        title: "The Silence of the Lambs",
        year: 1991
    },
    {
        title: "It's a Wonderful Life",
        year: 1946
    },
    {
        title: "Life Is Beautiful",
        year: 1997
    },
    {
        title: "The Usual Suspects",
        year: 1995
    },
    {
        title: "L\xe9on: The Professional",
        year: 1994
    },
    {
        title: "Spirited Away",
        year: 2001
    },
    {
        title: "Saving Private Ryan",
        year: 1998
    },
    {
        title: "Once Upon a Time in the West",
        year: 1968
    },
    {
        title: "American History X",
        year: 1998
    },
    {
        title: "Interstellar",
        year: 2014
    },
    {
        title: "Casablanca",
        year: 1942
    },
    {
        title: "City Lights",
        year: 1931
    },
    {
        title: "Psycho",
        year: 1960
    },
    {
        title: "The Green Mile",
        year: 1999
    },
    {
        title: "The Intouchables",
        year: 2011
    },
    {
        title: "Modern Times",
        year: 1936
    },
    {
        title: "Raiders of the Lost Ark",
        year: 1981
    },
    {
        title: "Rear Window",
        year: 1954
    },
    {
        title: "The Pianist",
        year: 2002
    },
    {
        title: "The Departed",
        year: 2006
    },
    {
        title: "Terminator 2: Judgment Day",
        year: 1991
    },
    {
        title: "Back to the Future",
        year: 1985
    },
    {
        title: "Whiplash",
        year: 2014
    },
    {
        title: "Gladiator",
        year: 2000
    },
    {
        title: "Memento",
        year: 2000
    },
    {
        title: "The Prestige",
        year: 2006
    },
    {
        title: "The Lion King",
        year: 1994
    },
    {
        title: "Apocalypse Now",
        year: 1979
    },
    {
        title: "Alien",
        year: 1979
    },
    {
        title: "Sunset Boulevard",
        year: 1950
    },
    {
        title: "Dr. Strangelove or: How I Learned to Stop Worrying and Love the Bomb",
        year: 1964
    },
    {
        title: "The Great Dictator",
        year: 1940
    },
    {
        title: "Cinema Paradiso",
        year: 1988
    },
    {
        title: "The Lives of Others",
        year: 2006
    },
    {
        title: "Grave of the Fireflies",
        year: 1988
    },
    {
        title: "Paths of Glory",
        year: 1957
    },
    {
        title: "Django Unchained",
        year: 2012
    },
    {
        title: "The Shining",
        year: 1980
    },
    {
        title: "WALL\xb7E",
        year: 2008
    },
    {
        title: "American Beauty",
        year: 1999
    },
    {
        title: "The Dark Knight Rises",
        year: 2012
    },
    {
        title: "Princess Mononoke",
        year: 1997
    },
    {
        title: "Aliens",
        year: 1986
    },
    {
        title: "Oldboy",
        year: 2003
    },
    {
        title: "Once Upon a Time in America",
        year: 1984
    },
    {
        title: "Witness for the Prosecution",
        year: 1957
    },
    {
        title: "Das Boot",
        year: 1981
    },
    {
        title: "Citizen Kane",
        year: 1941
    },
    {
        title: "North by Northwest",
        year: 1959
    },
    {
        title: "Vertigo",
        year: 1958
    },
    {
        title: "Star Wars: Episode VI - Return of the Jedi",
        year: 1983
    },
    {
        title: "Reservoir Dogs",
        year: 1992
    },
    {
        title: "Braveheart",
        year: 1995
    },
    {
        title: "M",
        year: 1931
    },
    {
        title: "Requiem for a Dream",
        year: 2000
    },
    {
        title: "Am\xe9lie",
        year: 2001
    },
    {
        title: "A Clockwork Orange",
        year: 1971
    },
    {
        title: "Like Stars on Earth",
        year: 2007
    },
    {
        title: "Taxi Driver",
        year: 1976
    },
    {
        title: "Lawrence of Arabia",
        year: 1962
    },
    {
        title: "Double Indemnity",
        year: 1944
    },
    {
        title: "Eternal Sunshine of the Spotless Mind",
        year: 2004
    },
    {
        title: "Amadeus",
        year: 1984
    },
    {
        title: "To Kill a Mockingbird",
        year: 1962
    },
    {
        title: "Toy Story 3",
        year: 2010
    },
    {
        title: "Logan",
        year: 2017
    },
    {
        title: "Full Metal Jacket",
        year: 1987
    },
    {
        title: "Dangal",
        year: 2016
    },
    {
        title: "The Sting",
        year: 1973
    },
    {
        title: "2001: A Space Odyssey",
        year: 1968
    },
    {
        title: "Singin' in the Rain",
        year: 1952
    },
    {
        title: "Toy Story",
        year: 1995
    },
    {
        title: "Bicycle Thieves",
        year: 1948
    },
    {
        title: "The Kid",
        year: 1921
    },
    {
        title: "Inglourious Basterds",
        year: 2009
    },
    {
        title: "Snatch",
        year: 2000
    },
    {
        title: "3 Idiots",
        year: 2009
    },
    {
        title: "Monty Python and the Holy Grail",
        year: 1975
    }, 
];

;// CONCATENATED MODULE: ./src/_mock/index.ts

// ----------------------------------------------------------------------










/* harmony default export */ var src_mock = ((/* unused pure expression or super */ null && (_mock)));

// EXTERNAL MODULE: ./src/components/Scrollbar.tsx
var Scrollbar = __webpack_require__(84855);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
;// CONCATENATED MODULE: ./src/components/BadgeStatus.tsx
// @mui



var RootStyle = (0,styled/* default */.ZP)("span")(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    var status = ownerState.status, size = ownerState.size;
    return (0,_object_spread/* default */.Z)({
        width: 10,
        height: 10,
        display: "flex",
        borderRadius: "50%",
        alignItems: "center",
        justifyContent: "center",
        "&:before, &:after": {
            content: "''",
            borderRadius: 1,
            backgroundColor: theme.palette.common.white
        }
    }, size === "small" && {
        width: 8,
        height: 8
    }, size === "large" && {
        width: 12,
        height: 12
    }, status === "offline" && {
        backgroundColor: "transparent"
    }, status === "away" && {
        backgroundColor: theme.palette.warning.main,
        "&:before": {
            width: 2,
            height: 4,
            transform: "translateX(1px) translateY(-1px)"
        },
        "&:after": {
            width: 2,
            height: 4,
            transform: "translateY(1px) rotate(125deg)"
        }
    }, status === "busy" && {
        backgroundColor: theme.palette.error.main,
        "&:before": {
            width: 6,
            height: 2
        }
    }, status === "online" && {
        backgroundColor: theme.palette.success.main
    }, status === "invisible" && {
        backgroundColor: theme.palette.text.disabled,
        "&:before": {
            width: 6,
            height: 6,
            borderRadius: "50%"
        }
    }, status === "unread" && {
        backgroundColor: theme.palette.info.main
    });
});
function BadgeStatus(param) {
    var _size = param.size, size = _size === void 0 ? "medium" : _size, _status = param.status, status = _status === void 0 ? "offline" : _status, sx = param.sx;
    var theme = (0,useTheme/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RootStyle, {
        ownerState: {
            status: status,
            size: size
        },
        sx: sx,
        theme: theme
    });
}

;// CONCATENATED MODULE: ./src/layouts/dashboard/header/ContactsPopover.tsx



// @mui


// utils

// _mock_

// components





// ----------------------------------------------------------------------
var ITEM_HEIGHT = 64;
// ----------------------------------------------------------------------
function ContactsPopover() {
    var ref = (0,react.useState)(null), open = ref[0], setOpen = ref[1];
    var handleOpen = function(event) {
        setOpen(event.currentTarget);
    };
    var handleClose = function() {
        setOpen(null);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(animate/* IconButtonAnimate */.w_, {
                color: open ? "primary" : "default",
                onClick: handleOpen,
                sx: (0,_object_spread/* default */.Z)({
                    width: 40,
                    height: 40
                }, open && {
                    bgcolor: function(theme) {
                        return (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.focusOpacity);
                    }
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                    icon: "eva:people-fill",
                    width: 20,
                    height: 20
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuPopover/* default */.Z, {
                open: Boolean(open),
                anchorEl: open,
                onClose: handleClose,
                sx: {
                    mt: 1.5,
                    ml: 0.75,
                    width: 320,
                    "& .MuiMenuItem-root": {
                        px: 1.5,
                        height: ITEM_HEIGHT,
                        borderRadius: 0.75
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        variant: "h6",
                        sx: {
                            p: 1.5
                        },
                        children: [
                            "Contacts ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                component: "span",
                                children: [
                                    "(",
                                    _contacts.length,
                                    ")"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Scrollbar/* default */.Z, {
                        sx: {
                            height: ITEM_HEIGHT * 6
                        },
                        children: _contacts.map(function(contact) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemAvatar/* default */.Z, {
                                        sx: {
                                            position: "relative"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                src: contact.avatar
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeStatus, {
                                                status: contact.status,
                                                sx: {
                                                    position: "absolute",
                                                    right: 1,
                                                    bottom: 1
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                        primaryTypographyProps: {
                                            typography: "subtitle2",
                                            mb: 0.25
                                        },
                                        secondaryTypographyProps: {
                                            typography: "caption"
                                        },
                                        primary: contact.name,
                                        secondary: contact.status === "offline" && (0,formatTime/* fToNow */.DY)(contact.lastActivity)
                                    })
                                ]
                            }, contact.id);
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Badge/Badge.js + 3 modules
var Badge = __webpack_require__(43694);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(34386);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListSubheader/ListSubheader.js + 1 modules
var ListSubheader = __webpack_require__(75438);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemButton/ListItemButton.js
var ListItemButton = __webpack_require__(98619);
;// CONCATENATED MODULE: ./src/layouts/dashboard/header/NotificationsPopover.tsx





// @mui

// utils

// _mock_

// components




// ----------------------------------------------------------------------
function NotificationsPopover() {
    var ref = (0,react.useState)(_notifications), notifications = ref[0], setNotifications = ref[1];
    var totalUnRead = notifications.filter(function(item) {
        return item.isUnRead === true;
    }).length;
    var ref1 = (0,react.useState)(null), open = ref1[0], setOpen = ref1[1];
    var handleOpen = function(event) {
        setOpen(event.currentTarget);
    };
    var handleClose = function() {
        setOpen(null);
    };
    var handleMarkAllAsRead = function() {
        setNotifications(notifications.map(function(notification) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, notification), {
                isUnRead: false
            });
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(animate/* IconButtonAnimate */.w_, {
                color: open ? "primary" : "default",
                onClick: handleOpen,
                sx: {
                    width: 40,
                    height: 40
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                    badgeContent: totalUnRead,
                    color: "error",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                        icon: "eva:bell-fill",
                        width: 20,
                        height: 20
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuPopover/* default */.Z, {
                open: Boolean(open),
                anchorEl: open,
                onClose: handleClose,
                sx: {
                    width: 360,
                    p: 0,
                    mt: 1.5,
                    ml: 0.75
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            py: 2,
                            px: 2.5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    flexGrow: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        children: "Notifications"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        variant: "body2",
                                        sx: {
                                            color: "text.secondary"
                                        },
                                        children: [
                                            "You have ",
                                            totalUnRead,
                                            " unread messages"
                                        ]
                                    })
                                ]
                            }),
                            totalUnRead > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                title: " Mark all as read",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(animate/* IconButtonAnimate */.w_, {
                                    color: "primary",
                                    onClick: handleMarkAllAsRead,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                        icon: "eva:done-all-fill",
                                        width: 20,
                                        height: 20
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        sx: {
                            borderStyle: "dashed"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Scrollbar/* default */.Z, {
                        sx: {
                            height: {
                                xs: 340,
                                sm: "auto"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                                disablePadding: true,
                                subheader: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListSubheader/* default */.Z, {
                                    disableSticky: true,
                                    sx: {
                                        py: 1,
                                        px: 2.5,
                                        typography: "overline"
                                    },
                                    children: "New"
                                }),
                                children: notifications.slice(0, 2).map(function(notification) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationItem, {
                                        notification: notification
                                    }, notification.id);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                                disablePadding: true,
                                subheader: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListSubheader/* default */.Z, {
                                    disableSticky: true,
                                    sx: {
                                        py: 1,
                                        px: 2.5,
                                        typography: "overline"
                                    },
                                    children: "Before that"
                                }),
                                children: notifications.slice(2, 5).map(function(notification) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationItem, {
                                        notification: notification
                                    }, notification.id);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        sx: {
                            borderStyle: "dashed"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            p: 1
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            fullWidth: true,
                            disableRipple: true,
                            children: "View All"
                        })
                    })
                ]
            })
        ]
    });
}
function NotificationItem(param) {
    var notification = param.notification;
    var ref = renderContent(notification), avatar = ref.avatar, title = ref.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton/* default */.Z, {
        sx: (0,_object_spread/* default */.Z)({
            py: 1.5,
            px: 2.5,
            mt: "1px"
        }, notification.isUnRead && {
            bgcolor: "action.selected"
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemAvatar/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    sx: {
                        bgcolor: "background.neutral"
                    },
                    children: avatar
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                primary: title,
                secondary: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "caption",
                    sx: {
                        mt: 0.5,
                        display: "flex",
                        alignItems: "center",
                        color: "text.disabled"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                            icon: "eva:clock-outline",
                            sx: {
                                mr: 0.5,
                                width: 16,
                                height: 16
                            }
                        }),
                        (0,formatTime/* fToNow */.DY)(notification.createdAt)
                    ]
                })
            })
        ]
    });
}
// ----------------------------------------------------------------------
function renderContent(notification) {
    var title = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
        variant: "subtitle2",
        children: [
            notification.title,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                component: "span",
                variant: "body2",
                sx: {
                    color: "text.secondary"
                },
                children: [
                    "\xa0 ",
                    (0,dist_es2015/* noCase */.B)(notification.description)
                ]
            })
        ]
    });
    if (notification.type === "order_placed") {
        return {
            avatar: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                alt: notification.title,
                src: "https://minimal-assets-api.vercel.app/assets/icons/ic_notification_package.svg"
            }),
            title: title
        };
    }
    if (notification.type === "order_shipped") {
        return {
            avatar: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                alt: notification.title,
                src: "https://minimal-assets-api.vercel.app/assets/icons/ic_notification_shipping.svg"
            }),
            title: title
        };
    }
    if (notification.type === "mail") {
        return {
            avatar: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                alt: notification.title,
                src: "https://minimal-assets-api.vercel.app/assets/icons/ic_notification_mail.svg"
            }),
            title: title
        };
    }
    if (notification.type === "chat_message") {
        return {
            avatar: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                alt: notification.title,
                src: "https://minimal-assets-api.vercel.app/assets/icons/ic_notification_chat.svg"
            }),
            title: title
        };
    }
    return {
        avatar: notification.avatar ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            alt: notification.title,
            src: notification.avatar
        }) : null,
        title: title
    };
}

;// CONCATENATED MODULE: ./src/layouts/dashboard/header/index.tsx
// @mui






// hooks


// utils

// config

// components



//





var header_RootStyle = (0,styled/* default */.ZP)(AppBar/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "isCollapse" && prop !== "isOffset" && prop !== "verticalLayout";
    }
})(function(param) {
    var isCollapse = param.isCollapse, isOffset = param.isOffset, verticalLayout = param.verticalLayout, theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,cssStyles/* default */.Z)(theme).bgBlur()), (0,_define_property/* default */.Z)({
        boxShadow: "none",
        height: config/* HEADER.MOBILE_HEIGHT */.yf.MOBILE_HEIGHT,
        zIndex: theme.zIndex.appBar + 1,
        transition: theme.transitions.create([
            "width",
            "height"
        ], {
            duration: theme.transitions.duration.shorter
        })
    }, theme.breakpoints.up("lg"), (0,_object_spread/* default */.Z)({
        height: config/* HEADER.DASHBOARD_DESKTOP_HEIGHT */.yf.DASHBOARD_DESKTOP_HEIGHT,
        width: "calc(100% - ".concat(config/* NAVBAR.DASHBOARD_WIDTH */.Au.DASHBOARD_WIDTH + 1, "px)")
    }, isCollapse && {
        width: "calc(100% - ".concat(config/* NAVBAR.DASHBOARD_COLLAPSE_WIDTH */.Au.DASHBOARD_COLLAPSE_WIDTH, "px)")
    }, isOffset && {
        height: config/* HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT */.yf.DASHBOARD_DESKTOP_OFFSET_HEIGHT
    }, verticalLayout && {
        width: "100%",
        height: config/* HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT */.yf.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
        backgroundColor: theme.palette.background.default
    })));
});
function DashboardHeader(param) {
    var onOpenSidebar = param.onOpenSidebar, _isCollapse = param.isCollapse, isCollapse = _isCollapse === void 0 ? false : _isCollapse, _verticalLayout = param.verticalLayout, verticalLayout = _verticalLayout === void 0 ? false : _verticalLayout;
    var isOffset = (0,useOffSetTop/* default */.Z)(config/* HEADER.DASHBOARD_DESKTOP_HEIGHT */.yf.DASHBOARD_DESKTOP_HEIGHT) && !verticalLayout;
    var isDesktop = (0,useResponsive/* default */.Z)("up", "lg");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(header_RootStyle, {
        isCollapse: isCollapse,
        isOffset: isOffset,
        verticalLayout: verticalLayout,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toolbar/* default */.Z, {
            sx: {
                minHeight: "100% !important",
                px: {
                    lg: 5
                }
            },
            children: [
                isDesktop && verticalLayout && /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                    sx: {
                        mr: 2.5
                    }
                }),
                !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(animate/* IconButtonAnimate */.w_, {
                    onClick: onOpenSidebar,
                    sx: {
                        mr: 1,
                        color: "text.primary"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                        icon: "eva:menu-2-fill"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Searchbar, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        flexGrow: 1
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    spacing: {
                        xs: 0.5,
                        sm: 1.5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguagePopover/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationsPopover, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactsPopover, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountPopover, {})
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 1 modules
var Drawer = __webpack_require__(58826);
// EXTERNAL MODULE: ./src/components/nav-section/index.ts + 6 modules
var nav_section = __webpack_require__(45291);
// EXTERNAL MODULE: ./src/components/Label.tsx
var Label = __webpack_require__(4930);
// EXTERNAL MODULE: ./src/components/SvgIconStyle.tsx
var SvgIconStyle = __webpack_require__(58432);
;// CONCATENATED MODULE: ./src/layouts/dashboard/navbar/NavConfig.tsx
// routes


// components


// ----------------------------------------------------------------------
var getIcon = function(name) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIconStyle/* default */.Z, {
        src: "/icons/".concat(name, ".svg"),
        sx: {
            width: 1,
            height: 1
        }
    });
};
var ICONS = {
    blog: getIcon("ic_blog"),
    cart: getIcon("ic_cart"),
    chat: getIcon("ic_chat"),
    mail: getIcon("ic_mail"),
    user: getIcon("ic_user"),
    kanban: getIcon("ic_kanban"),
    banking: getIcon("ic_banking"),
    calendar: getIcon("ic_calendar"),
    ecommerce: getIcon("ic_ecommerce"),
    analytics: getIcon("ic_analytics"),
    dashboard: getIcon("ic_dashboard"),
    booking: getIcon("ic_booking")
};
var navConfig = [
    // GENERAL
    // ----------------------------------------------------------------------
    {
        subheader: "general",
        items: [
            {
                title: "app",
                path: paths/* PATH_DASHBOARD.general.app */.vB.general.app,
                icon: ICONS.dashboard
            },
            {
                title: "e-commerce",
                path: paths/* PATH_DASHBOARD.general.ecommerce */.vB.general.ecommerce,
                icon: ICONS.ecommerce
            },
            {
                title: "analytics",
                path: paths/* PATH_DASHBOARD.general.analytics */.vB.general.analytics,
                icon: ICONS.analytics
            },
            {
                title: "banking",
                path: paths/* PATH_DASHBOARD.general.banking */.vB.general.banking,
                icon: ICONS.banking
            },
            {
                title: "booking",
                path: paths/* PATH_DASHBOARD.general.booking */.vB.general.booking,
                icon: ICONS.booking
            }, 
        ]
    },
    // MANAGEMENT
    // ----------------------------------------------------------------------
    {
        subheader: "management",
        items: [
            // MANAGEMENT : USER
            {
                title: "user",
                path: paths/* PATH_DASHBOARD.user.root */.vB.user.root,
                icon: ICONS.user,
                children: [
                    {
                        title: "profile",
                        path: paths/* PATH_DASHBOARD.user.profile */.vB.user.profile
                    },
                    {
                        title: "cards",
                        path: paths/* PATH_DASHBOARD.user.cards */.vB.user.cards
                    },
                    {
                        title: "list",
                        path: paths/* PATH_DASHBOARD.user.list */.vB.user.list
                    },
                    {
                        title: "create",
                        path: paths/* PATH_DASHBOARD.user.newUser */.vB.user.newUser
                    },
                    {
                        title: "edit",
                        path: paths/* PATH_DASHBOARD.user.editById */.vB.user.editById
                    },
                    {
                        title: "account",
                        path: paths/* PATH_DASHBOARD.user.account */.vB.user.account
                    }, 
                ]
            },
            // MANAGEMENT : E-COMMERCE
            {
                title: "e-commerce",
                path: paths/* PATH_DASHBOARD.eCommerce.root */.vB.eCommerce.root,
                icon: ICONS.cart,
                children: [
                    {
                        title: "shop",
                        path: paths/* PATH_DASHBOARD.eCommerce.shop */.vB.eCommerce.shop
                    },
                    {
                        title: "product",
                        path: paths/* PATH_DASHBOARD.eCommerce.productById */.vB.eCommerce.productById
                    },
                    {
                        title: "list",
                        path: paths/* PATH_DASHBOARD.eCommerce.list */.vB.eCommerce.list
                    },
                    {
                        title: "create",
                        path: paths/* PATH_DASHBOARD.eCommerce.newProduct */.vB.eCommerce.newProduct
                    },
                    {
                        title: "edit",
                        path: paths/* PATH_DASHBOARD.eCommerce.editById */.vB.eCommerce.editById
                    },
                    {
                        title: "checkout",
                        path: paths/* PATH_DASHBOARD.eCommerce.checkout */.vB.eCommerce.checkout
                    },
                    {
                        title: "invoice",
                        path: paths/* PATH_DASHBOARD.eCommerce.invoice */.vB.eCommerce.invoice
                    }, 
                ]
            },
            // MANAGEMENT : BLOG
            {
                title: "blog",
                path: paths/* PATH_DASHBOARD.blog.root */.vB.blog.root,
                icon: ICONS.blog,
                children: [
                    {
                        title: "posts",
                        path: paths/* PATH_DASHBOARD.blog.posts */.vB.blog.posts
                    },
                    {
                        title: "post",
                        path: paths/* PATH_DASHBOARD.blog.postById */.vB.blog.postById
                    },
                    {
                        title: "new post",
                        path: paths/* PATH_DASHBOARD.blog.newPost */.vB.blog.newPost
                    }, 
                ]
            }, 
        ]
    },
    // APP
    // ----------------------------------------------------------------------
    {
        subheader: "app",
        items: [
            {
                title: "mail",
                path: paths/* PATH_DASHBOARD.mail.root */.vB.mail.root,
                icon: ICONS.mail,
                info: /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                    variant: "outlined",
                    color: "error",
                    children: "+32"
                })
            },
            {
                title: "chat",
                path: paths/* PATH_DASHBOARD.chat.root */.vB.chat.root,
                icon: ICONS.chat
            },
            {
                title: "calendar",
                path: paths/* PATH_DASHBOARD.calendar */.vB.calendar,
                icon: ICONS.calendar
            },
            {
                title: "kanban",
                path: paths/* PATH_DASHBOARD.kanban */.vB.kanban,
                icon: ICONS.kanban
            }, 
        ]
    }, 
];
/* harmony default export */ var NavConfig = (navConfig);

;// CONCATENATED MODULE: ./src/layouts/dashboard/navbar/NavbarDocs.tsx
// @mui


// hooks

// routes

// assets

// ----------------------------------------------------------------------
function NavbarDocs() {
    var user = (0,useAuth/* default */.Z)().user;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        spacing: 3,
        sx: {
            px: 5,
            pb: 5,
            mt: 10,
            width: 1,
            textAlign: "center",
            display: "block"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(assets/* DocIllustration */.CJ, {
                sx: {
                    width: 1
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        gutterBottom: true,
                        variant: "subtitle1",
                        children: [
                            "Hi, ",
                            user === null || user === void 0 ? void 0 : user.displayName
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        variant: "body2",
                        sx: {
                            color: "text.secondary"
                        },
                        children: [
                            "Need help?",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " Please check our docs"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                href: paths/* PATH_DOCS */.Au,
                target: "_blank",
                rel: "noopener",
                variant: "contained",
                children: "Documentation"
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(50122);
;// CONCATENATED MODULE: ./src/layouts/dashboard/navbar/NavbarAccount.tsx
// next



// @mui


// hooks

// routes

// components

// ----------------------------------------------------------------------
var NavbarAccount_RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(2, 2.5),
        borderRadius: Number(theme.shape.borderRadius) * 1.5,
        backgroundColor: theme.palette.grey[50012],
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    };
});
function NavbarAccount(param) {
    var isCollapse = param.isCollapse;
    var user = (0,useAuth/* default */.Z)().user;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: paths/* PATH_DASHBOARD.user.account */.vB.user.account,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            underline: "none",
            color: "inherit",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavbarAccount_RootStyle, {
                sx: (0,_object_spread/* default */.Z)({}, isCollapse && {
                    bgcolor: "transparent"
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MyAvatar/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: (0,_object_spread/* default */.Z)({
                            ml: 2,
                            transition: function(theme) {
                                return theme.transitions.create("width", {
                                    duration: theme.transitions.duration.shorter
                                });
                            }
                        }, isCollapse && {
                            ml: 0,
                            width: 0
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle2",
                                noWrap: true,
                                children: user === null || user === void 0 ? void 0 : user.displayName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body2",
                                noWrap: true,
                                sx: {
                                    color: "text.secondary"
                                },
                                children: user === null || user === void 0 ? void 0 : user.role
                            })
                        ]
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/layouts/dashboard/navbar/CollapseButton.tsx
// @mui



// components

function CollapseButton(param) {
    var onToggleCollapse = param.onToggleCollapse, collapseClick = param.collapseClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(animate/* IconButtonAnimate */.w_, {
        onClick: onToggleCollapse,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: (0,_object_spread/* default */.Z)({
                lineHeight: 0,
                transition: function(theme) {
                    return theme.transitions.create("transform", {
                        duration: theme.transitions.duration.shorter
                    });
                }
            }, collapseClick && {
                transform: "rotate(180deg)"
            }),
            children: icon
        })
    });
}
// ----------------------------------------------------------------------
var icon = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    width: "24",
    height: "24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
        fill: "none",
        fillRule: "evenodd",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "currentColor",
                fillRule: "nonzero",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.3283 11.4343 18.5126 7.25c.4142-.4142.4142-1.0858 0-1.5-.4142-.4142-1.0858-.4142-1.5 0l-5.543 5.5429c-.3904.3905-.3904 1.0237 0 1.4142l5.543 5.5429c.4142.4142 1.0858.4142 1.5 0 .4142-.4142.4142-1.0858 0-1.5l-4.1843-4.1843a.8.8 0 0 1 0-1.1314Z",
                        opacity: ".48"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.3283 11.4343 12.5126 7.25c.4142-.4142.4142-1.0858 0-1.5-.4142-.4142-1.0858-.4142-1.5 0l-5.543 5.5429c-.3904.3905-.3904 1.0237 0 1.4142l5.543 5.5429c.4142.4142 1.0858.4142 1.5 0 .4142-.4142.4142-1.0858 0-1.5l-4.1843-4.1843a.8.8 0 0 1 0-1.1314Z"
                    })
                ]
            })
        ]
    })
});

;// CONCATENATED MODULE: ./src/layouts/dashboard/navbar/NavbarVertical.tsx





// next

// @mui


// hooks


// utils

// config

// components



//




// ----------------------------------------------------------------------
var NavbarVertical_RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({}, theme.breakpoints.up("lg"), {
        flexShrink: 0,
        transition: theme.transitions.create("width", {
            duration: theme.transitions.duration.shorter
        })
    });
});
function NavbarVertical(param) {
    var isOpenSidebar = param.isOpenSidebar, onCloseSidebar = param.onCloseSidebar;
    var theme = (0,useTheme/* default */.Z)();
    var pathname = (0,next_router.useRouter)().pathname;
    var isDesktop = (0,useResponsive/* default */.Z)("up", "lg");
    var ref = (0,useCollapseDrawer/* default */.Z)(), isCollapse = ref.isCollapse, collapseClick = ref.collapseClick, collapseHover = ref.collapseHover, onToggleCollapse = ref.onToggleCollapse, onHoverEnter = ref.onHoverEnter, onHoverLeave = ref.onHoverLeave;
    (0,react.useEffect)(function() {
        if (isOpenSidebar) {
            onCloseSidebar();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pathname
    ]);
    var renderContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Scrollbar/* default */.Z, {
        sx: {
            height: 1,
            "& .simplebar-content": {
                height: 1,
                display: "flex",
                flexDirection: "column"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 3,
                sx: (0,_object_spread/* default */.Z)({
                    pt: 3,
                    pb: 2,
                    px: 2.5,
                    flexShrink: 0
                }, isCollapse && {
                    alignItems: "center"
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {}),
                            isDesktop && !isCollapse && /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapseButton, {
                                onToggleCollapse: onToggleCollapse,
                                collapseClick: collapseClick
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarAccount, {
                        isCollapse: isCollapse
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(nav_section/* NavSectionVertical */.Mr, {
                navConfig: NavConfig,
                isCollapse: isCollapse
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    flexGrow: 1
                }
            }),
            !isCollapse && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarDocs, {})
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavbarVertical_RootStyle, {
        sx: (0,_object_spread/* default */.Z)({
            width: {
                lg: isCollapse ? config/* NAVBAR.DASHBOARD_COLLAPSE_WIDTH */.Au.DASHBOARD_COLLAPSE_WIDTH : config/* NAVBAR.DASHBOARD_WIDTH */.Au.DASHBOARD_WIDTH
            }
        }, collapseClick && {
            position: "absolute"
        }),
        children: [
            !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
                open: isOpenSidebar,
                onClose: onCloseSidebar,
                PaperProps: {
                    sx: {
                        width: config/* NAVBAR.DASHBOARD_WIDTH */.Au.DASHBOARD_WIDTH
                    }
                },
                children: renderContent
            }),
            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
                open: true,
                variant: "persistent",
                onMouseEnter: onHoverEnter,
                onMouseLeave: onHoverLeave,
                PaperProps: {
                    sx: (0,_object_spread/* default */.Z)({
                        width: config/* NAVBAR.DASHBOARD_WIDTH */.Au.DASHBOARD_WIDTH,
                        borderRightStyle: "dashed",
                        bgcolor: "background.default",
                        transition: function(theme) {
                            return theme.transitions.create("width", {
                                duration: theme.transitions.duration.standard
                            });
                        }
                    }, isCollapse && {
                        width: config/* NAVBAR.DASHBOARD_COLLAPSE_WIDTH */.Au.DASHBOARD_COLLAPSE_WIDTH
                    }, collapseHover && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,cssStyles/* default */.Z)(theme).bgBlur()), {
                        boxShadow: function(theme) {
                            return theme.customShadows.z24;
                        }
                    }))
                },
                children: renderContent
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(27948);
;// CONCATENATED MODULE: ./src/layouts/dashboard/navbar/NavbarHorizontal.tsx


// @mui


// config

// components

//

// ----------------------------------------------------------------------
var NavbarHorizontal_RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return {
        transition: theme.transitions.create("top", {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter
        }),
        width: "100%",
        position: "fixed",
        zIndex: theme.zIndex.appBar,
        padding: theme.spacing(1, 0),
        boxShadow: theme.customShadows.z8,
        top: config/* HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT */.yf.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
        backgroundColor: theme.palette.background.default
    };
});
// ----------------------------------------------------------------------
function NavbarHorizontal() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarHorizontal_RootStyle, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: false,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(nav_section/* NavSectionHorizontal */.EM, {
                navConfig: NavConfig
            })
        })
    });
}
/* harmony default export */ var navbar_NavbarHorizontal = (/*#__PURE__*/(0,react.memo)(NavbarHorizontal));

;// CONCATENATED MODULE: ./src/layouts/dashboard/index.tsx




// @mui


// hooks



// config

//



var MainStyle = (0,styled/* default */.ZP)("main", {
    shouldForwardProp: function(prop) {
        return prop !== "collapseClick";
    }
})(function(param) {
    var collapseClick = param.collapseClick, theme = param.theme;
    return (0,_define_property/* default */.Z)({
        flexGrow: 1,
        paddingTop: config/* HEADER.MOBILE_HEIGHT */.yf.MOBILE_HEIGHT + 24,
        paddingBottom: config/* HEADER.MOBILE_HEIGHT */.yf.MOBILE_HEIGHT + 24
    }, theme.breakpoints.up("lg"), (0,_object_spread/* default */.Z)({
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: config/* HEADER.DASHBOARD_DESKTOP_HEIGHT */.yf.DASHBOARD_DESKTOP_HEIGHT + 24,
        paddingBottom: config/* HEADER.DASHBOARD_DESKTOP_HEIGHT */.yf.DASHBOARD_DESKTOP_HEIGHT + 24,
        width: "calc(100% - ".concat(config/* NAVBAR.DASHBOARD_WIDTH */.Au.DASHBOARD_WIDTH, "px)"),
        transition: theme.transitions.create("margin-left", {
            duration: theme.transitions.duration.shorter
        })
    }, collapseClick && {
        marginLeft: config/* NAVBAR.DASHBOARD_COLLAPSE_WIDTH */.Au.DASHBOARD_COLLAPSE_WIDTH
    }));
});
function DashboardLayout(param) {
    var children = param.children;
    var ref = (0,useCollapseDrawer/* default */.Z)(), collapseClick = ref.collapseClick, isCollapse = ref.isCollapse;
    var themeLayout = (0,useSettings/* default */.Z)().themeLayout;
    var isDesktop = (0,useResponsive/* default */.Z)("up", "lg");
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var verticalLayout = themeLayout === "vertical";
    if (verticalLayout) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardHeader, {
                    onOpenSidebar: function() {
                        return setOpen(true);
                    },
                    verticalLayout: verticalLayout
                }),
                isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar_NavbarHorizontal, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarVertical, {
                    isOpenSidebar: open,
                    onCloseSidebar: function() {
                        return setOpen(false);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    component: "main",
                    sx: {
                        px: {
                            lg: 2
                        },
                        pt: {
                            xs: "".concat(config/* HEADER.MOBILE_HEIGHT */.yf.MOBILE_HEIGHT + 24, "px"),
                            lg: "".concat(config/* HEADER.DASHBOARD_DESKTOP_HEIGHT */.yf.DASHBOARD_DESKTOP_HEIGHT + 80, "px")
                        },
                        pb: {
                            xs: "".concat(config/* HEADER.MOBILE_HEIGHT */.yf.MOBILE_HEIGHT + 24, "px"),
                            lg: "".concat(config/* HEADER.DASHBOARD_DESKTOP_HEIGHT */.yf.DASHBOARD_DESKTOP_HEIGHT + 24, "px")
                        }
                    },
                    children: children
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            display: {
                lg: "flex"
            },
            minHeight: {
                lg: 1
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardHeader, {
                isCollapse: isCollapse,
                onOpenSidebar: function() {
                    return setOpen(true);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarVertical, {
                isOpenSidebar: open,
                onCloseSidebar: function() {
                    return setOpen(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainStyle, {
                collapseClick: collapseClick,
                children: children
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/layouts/LogoOnlyLayout.tsx


// @mui

// components

// ----------------------------------------------------------------------
var HeaderStyle = (0,styled/* default */.ZP)("header")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        top: 0,
        left: 0,
        lineHeight: 0,
        width: "100%",
        position: "absolute",
        padding: theme.spacing(3, 3, 0)
    }, theme.breakpoints.up("sm"), {
        padding: theme.spacing(5, 5, 0)
    });
});
function LogoOnlyLayout(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderStyle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {})
            }),
            children
        ]
    });
}

// EXTERNAL MODULE: ./src/hooks/useApp.ts
var useApp = __webpack_require__(28821);
// EXTERNAL MODULE: ./src/layouts/shared/AccountPopover.tsx
var shared_AccountPopover = __webpack_require__(90216);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/hooks/useLocales.ts + 3 modules
var useLocales = __webpack_require__(67918);
// EXTERNAL MODULE: ./src/appConfig.ts + 1 modules
var appConfig = __webpack_require__(83330);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(29430);
;// CONCATENATED MODULE: ./src/layouts/admin/header/LanguagePopover.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (max-width: 768px) {\n    width: 28px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var StyledImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-29ec7711-0"
})(_templateObject());
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-29ec7711-1"
})(_templateObject1(), function(props) {
    return props.fullWidth && "width: 100%;";
});
function LanguagePopover_LanguagePopover(props) {
    var ref = (0,useLocales/* default */.Z)(), allLang = ref.allLang, currentLang = ref.currentLang, onChangeLang = ref.onChangeLang;
    var ref1 = (0,useApp/* default */.Z)(), appId = ref1.id;
    var ref2 = (0,react.useState)(null), open = ref2[0], setOpen = ref2[1];
    var appLocales = appConfig/* APP_LOCALES.filter */.VL.filter(function(appLocale) {
        return appLocale.appId === appId;
    }).map(function(appLocale) {
        return appLocale.value;
    });
    var handleOpen = function(event) {
        setOpen(event.currentTarget);
    };
    var handleClose = function() {
        setOpen(null);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                fullWidth: props.fullWidth,
                onClick: handleOpen,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(animate/* IconButtonAnimate */.w_, {
                        sx: (0,_object_spread/* default */.Z)({
                            width: 40,
                            height: 40
                        }, open && {
                            bgcolor: "action.selected"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                            src: currentLang.icon,
                            alt: currentLang.label
                        })
                    }),
                    props.showLanguageText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body1",
                        children: currentLang.label
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuPopover/* default */.Z, {
                open: Boolean(open),
                anchorEl: open,
                onClose: handleClose,
                sx: {
                    mt: 1.5,
                    ml: 0.75,
                    width: 180,
                    "& .MuiMenuItem-root": {
                        px: 1,
                        typography: "body2",
                        borderRadius: 0.75
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    spacing: 0.75,
                    children: allLang.filter(function(param) {
                        var value = param.value;
                        return appLocales.includes(value);
                    }).map(function(option) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                            selected: option.value === currentLang.value,
                            onClick: function() {
                                onChangeLang(option.value);
                                handleClose();
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                                    alt: option.label,
                                    src: option.icon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    style: {
                                        marginLeft: 10
                                    },
                                    children: option.label
                                })
                            ]
                        }, option.value);
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/layouts/admin/header/index.tsx
// @mui






// hooks


// utils

// config

// components



//


var admin_header_RootStyle = (0,styled/* default */.ZP)(AppBar/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "isCollapse" && prop !== "isOffset" && prop !== "verticalLayout";
    }
})(function(param) {
    var isCollapse = param.isCollapse, isOffset = param.isOffset, verticalLayout = param.verticalLayout, theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,cssStyles/* default */.Z)(theme).bgBlur()), (0,_define_property/* default */.Z)({
        boxShadow: "none",
        height: config/* HEADER.MOBILE_HEIGHT */.yf.MOBILE_HEIGHT,
        zIndex: theme.zIndex.appBar + 1,
        transition: theme.transitions.create([
            "width",
            "height"
        ], {
            duration: theme.transitions.duration.shorter
        })
    }, theme.breakpoints.up("lg"), (0,_object_spread/* default */.Z)({
        height: config/* HEADER.DASHBOARD_DESKTOP_HEIGHT */.yf.DASHBOARD_DESKTOP_HEIGHT,
        width: "calc(100% - ".concat(config/* NAVBAR.DASHBOARD_WIDTH */.Au.DASHBOARD_WIDTH + 1, "px)")
    }, isCollapse && {
        width: "calc(100% - ".concat(config/* NAVBAR.DASHBOARD_COLLAPSE_WIDTH */.Au.DASHBOARD_COLLAPSE_WIDTH, "px)")
    }, isOffset && {
        height: config/* HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT */.yf.DASHBOARD_DESKTOP_OFFSET_HEIGHT
    }, verticalLayout && {
        width: "100%",
        height: config/* HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT */.yf.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
        backgroundColor: theme.palette.background.default
    })));
});
function AdminHeader(param) {
    var onOpenSidebar = param.onOpenSidebar, _isCollapse = param.isCollapse, isCollapse = _isCollapse === void 0 ? false : _isCollapse, _verticalLayout = param.verticalLayout, verticalLayout = _verticalLayout === void 0 ? false : _verticalLayout;
    var isOffset = (0,useOffSetTop/* default */.Z)(config/* HEADER.DASHBOARD_DESKTOP_HEIGHT */.yf.DASHBOARD_DESKTOP_HEIGHT) && !verticalLayout;
    var isDesktop = (0,useResponsive/* default */.Z)("up", "lg");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(admin_header_RootStyle, {
        isCollapse: isCollapse,
        isOffset: isOffset,
        verticalLayout: verticalLayout,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toolbar/* default */.Z, {
            sx: {
                minHeight: "100% !important",
                px: {
                    lg: 5
                }
            },
            children: [
                isDesktop && verticalLayout && /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                    sx: {
                        mr: 2.5
                    }
                }),
                !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(animate/* IconButtonAnimate */.w_, {
                    onClick: onOpenSidebar,
                    sx: {
                        mr: 1,
                        color: "text.primary"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                        icon: "eva:menu-2-fill"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        flexGrow: 1
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    spacing: {
                        xs: 0.5,
                        sm: 1.5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguagePopover_LanguagePopover, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_AccountPopover/* default */.Z, {})
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/layouts/admin/navbar/NavConfig.tsx
// routes



// ----------------------------------------------------------------------
var NavConfig_getIcon = function(name) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIconStyle/* default */.Z, {
        src: "/icons/".concat(name, ".svg"),
        sx: {
            width: 1,
            height: 1
        }
    });
};
var NavConfig_ICONS = {
    blog: NavConfig_getIcon("ic_blog"),
    cart: NavConfig_getIcon("ic_cart"),
    chat: NavConfig_getIcon("ic_chat"),
    mail: NavConfig_getIcon("ic_mail"),
    user: NavConfig_getIcon("ic_user"),
    kanban: NavConfig_getIcon("ic_kanban"),
    banking: NavConfig_getIcon("ic_banking"),
    calendar: NavConfig_getIcon("ic_calendar"),
    ecommerce: NavConfig_getIcon("ic_ecommerce"),
    analytics: NavConfig_getIcon("ic_analytics"),
    dashboard: NavConfig_getIcon("ic_dashboard"),
    booking: NavConfig_getIcon("ic_booking")
};
var NavConfig_navConfig = [
    {
        subheader: "general",
        items: [
            {
                title: "forms",
                path: paths/* PATH_ADMIN.general.forms */.BO.general.forms,
                icon: NavConfig_ICONS.analytics
            }
        ]
    },
    {
        subheader: "management",
        items: [
            {
                title: "blog",
                path: paths/* PATH_ADMIN.blog.root */.BO.blog.root,
                icon: NavConfig_ICONS.blog,
                children: [
                    {
                        title: "posts",
                        path: paths/* PATH_ADMIN.blog.posts */.BO.blog.posts
                    }
                ]
            }, 
        ]
    }, 
];
/* harmony default export */ var navbar_NavConfig = (NavConfig_navConfig);

;// CONCATENATED MODULE: ./src/layouts/admin/navbar/NavbarDocs.tsx
// @mui


// hooks

// assets

// ----------------------------------------------------------------------
function NavbarDocs_NavbarDocs() {
    var user = (0,useAuth/* default */.Z)().user;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        spacing: 3,
        sx: {
            px: 5,
            pb: 5,
            mt: 10,
            width: 1,
            textAlign: "center",
            display: "block"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(assets/* DocIllustration */.CJ, {
                sx: {
                    width: 1
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        gutterBottom: true,
                        variant: "subtitle1",
                        children: [
                            "Hi, ",
                            user === null || user === void 0 ? void 0 : user.displayName
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        variant: "body2",
                        sx: {
                            color: "text.secondary"
                        },
                        children: [
                            "Need help?",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " Please contact us"
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/layouts/admin/navbar/NavbarAccount.tsx
// next



// @mui


// hooks

// components

// ----------------------------------------------------------------------
var navbar_NavbarAccount_RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(2, 2.5),
        borderRadius: Number(theme.shape.borderRadius) * 1.5,
        backgroundColor: theme.palette.grey[50012],
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    };
});
function NavbarAccount_NavbarAccount(param) {
    var isCollapse = param.isCollapse;
    var user = (0,useAuth/* default */.Z)().user;
    return(// TODO link to user account page
    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/",
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            underline: "none",
            color: "inherit",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(navbar_NavbarAccount_RootStyle, {
                sx: (0,_object_spread/* default */.Z)({}, isCollapse && {
                    bgcolor: "transparent"
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MyAvatar/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: (0,_object_spread/* default */.Z)({
                            ml: 2,
                            transition: function(theme) {
                                return theme.transitions.create("width", {
                                    duration: theme.transitions.duration.shorter
                                });
                            }
                        }, isCollapse && {
                            ml: 0,
                            width: 0
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle2",
                                noWrap: true,
                                children: user === null || user === void 0 ? void 0 : user.displayName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body2",
                                noWrap: true,
                                sx: {
                                    color: "text.secondary"
                                },
                                children: user === null || user === void 0 ? void 0 : user.role
                            })
                        ]
                    })
                ]
            })
        })
    }));
}

;// CONCATENATED MODULE: ./src/layouts/admin/navbar/CollapseButton.tsx
// @mui



// components

function CollapseButton_CollapseButton(param) {
    var onToggleCollapse = param.onToggleCollapse, collapseClick = param.collapseClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(animate/* IconButtonAnimate */.w_, {
        onClick: onToggleCollapse,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: (0,_object_spread/* default */.Z)({
                lineHeight: 0,
                transition: function(theme) {
                    return theme.transitions.create("transform", {
                        duration: theme.transitions.duration.shorter
                    });
                }
            }, collapseClick && {
                transform: "rotate(180deg)"
            }),
            children: CollapseButton_icon
        })
    });
}
// ----------------------------------------------------------------------
var CollapseButton_icon = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    width: "24",
    height: "24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
        fill: "none",
        fillRule: "evenodd",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "currentColor",
                fillRule: "nonzero",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.3283 11.4343 18.5126 7.25c.4142-.4142.4142-1.0858 0-1.5-.4142-.4142-1.0858-.4142-1.5 0l-5.543 5.5429c-.3904.3905-.3904 1.0237 0 1.4142l5.543 5.5429c.4142.4142 1.0858.4142 1.5 0 .4142-.4142.4142-1.0858 0-1.5l-4.1843-4.1843a.8.8 0 0 1 0-1.1314Z",
                        opacity: ".48"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.3283 11.4343 12.5126 7.25c.4142-.4142.4142-1.0858 0-1.5-.4142-.4142-1.0858-.4142-1.5 0l-5.543 5.5429c-.3904.3905-.3904 1.0237 0 1.4142l5.543 5.5429c.4142.4142 1.0858.4142 1.5 0 .4142-.4142.4142-1.0858 0-1.5l-4.1843-4.1843a.8.8 0 0 1 0-1.1314Z"
                    })
                ]
            })
        ]
    })
});

;// CONCATENATED MODULE: ./src/layouts/admin/navbar/NavbarVertical.tsx





// next

// @mui


// hooks


// utils

// config

// components



//




// ----------------------------------------------------------------------
var navbar_NavbarVertical_RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({}, theme.breakpoints.up("lg"), {
        flexShrink: 0,
        transition: theme.transitions.create("width", {
            duration: theme.transitions.duration.shorter
        })
    });
});
function NavbarVertical_NavbarVertical(param) {
    var isOpenSidebar = param.isOpenSidebar, onCloseSidebar = param.onCloseSidebar;
    var theme = (0,useTheme/* default */.Z)();
    var pathname = (0,next_router.useRouter)().pathname;
    var isDesktop = (0,useResponsive/* default */.Z)("up", "lg");
    var ref = (0,useCollapseDrawer/* default */.Z)(), isCollapse = ref.isCollapse, collapseClick = ref.collapseClick, collapseHover = ref.collapseHover, onToggleCollapse = ref.onToggleCollapse, onHoverEnter = ref.onHoverEnter, onHoverLeave = ref.onHoverLeave;
    (0,react.useEffect)(function() {
        if (isOpenSidebar) {
            onCloseSidebar();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pathname
    ]);
    var renderContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Scrollbar/* default */.Z, {
        sx: {
            height: 1,
            "& .simplebar-content": {
                height: 1,
                display: "flex",
                flexDirection: "column"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 3,
                sx: (0,_object_spread/* default */.Z)({
                    pt: 3,
                    pb: 2,
                    px: 2.5,
                    flexShrink: 0
                }, isCollapse && {
                    alignItems: "center"
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {}),
                            isDesktop && !isCollapse && /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapseButton_CollapseButton, {
                                onToggleCollapse: onToggleCollapse,
                                collapseClick: collapseClick
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarAccount_NavbarAccount, {
                        isCollapse: isCollapse
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(nav_section/* NavSectionVertical */.Mr, {
                navConfig: navbar_NavConfig,
                isCollapse: isCollapse
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    flexGrow: 1
                }
            }),
            !isCollapse && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarDocs_NavbarDocs, {})
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(navbar_NavbarVertical_RootStyle, {
        sx: (0,_object_spread/* default */.Z)({
            width: {
                lg: isCollapse ? config/* NAVBAR.DASHBOARD_COLLAPSE_WIDTH */.Au.DASHBOARD_COLLAPSE_WIDTH : config/* NAVBAR.DASHBOARD_WIDTH */.Au.DASHBOARD_WIDTH
            }
        }, collapseClick && {
            position: "absolute"
        }),
        children: [
            !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
                open: isOpenSidebar,
                onClose: onCloseSidebar,
                PaperProps: {
                    sx: {
                        width: config/* NAVBAR.DASHBOARD_WIDTH */.Au.DASHBOARD_WIDTH
                    }
                },
                children: renderContent
            }),
            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
                open: true,
                variant: "persistent",
                onMouseEnter: onHoverEnter,
                onMouseLeave: onHoverLeave,
                PaperProps: {
                    sx: (0,_object_spread/* default */.Z)({
                        width: config/* NAVBAR.DASHBOARD_WIDTH */.Au.DASHBOARD_WIDTH,
                        borderRightStyle: "dashed",
                        bgcolor: "background.default",
                        transition: function(theme) {
                            return theme.transitions.create("width", {
                                duration: theme.transitions.duration.standard
                            });
                        }
                    }, isCollapse && {
                        width: config/* NAVBAR.DASHBOARD_COLLAPSE_WIDTH */.Au.DASHBOARD_COLLAPSE_WIDTH
                    }, collapseHover && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,cssStyles/* default */.Z)(theme).bgBlur()), {
                        boxShadow: function(theme) {
                            return theme.customShadows.z24;
                        }
                    }))
                },
                children: renderContent
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/layouts/admin/navbar/NavbarHorizontal.tsx


// @mui


// config

// components

//

// ----------------------------------------------------------------------
var navbar_NavbarHorizontal_RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return {
        transition: theme.transitions.create("top", {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter
        }),
        width: "100%",
        position: "fixed",
        zIndex: theme.zIndex.appBar,
        padding: theme.spacing(1, 0),
        boxShadow: theme.customShadows.z8,
        top: config/* HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT */.yf.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
        backgroundColor: theme.palette.background.default
    };
});
// ----------------------------------------------------------------------
function NavbarHorizontal_NavbarHorizontal() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar_NavbarHorizontal_RootStyle, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: false,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(nav_section/* NavSectionHorizontal */.EM, {
                navConfig: navbar_NavConfig
            })
        })
    });
}
/* harmony default export */ var admin_navbar_NavbarHorizontal = (/*#__PURE__*/(0,react.memo)(NavbarHorizontal_NavbarHorizontal));

// EXTERNAL MODULE: ./src/components/LoadingScreen.tsx
var LoadingScreen = __webpack_require__(12030);
;// CONCATENATED MODULE: ./src/layouts/admin/index.tsx




// @mui


// hooks





// config

//






var admin_MainStyle = (0,styled/* default */.ZP)("main", {
    shouldForwardProp: function(prop) {
        return prop !== "collapseClick";
    }
})(function(param) {
    var collapseClick = param.collapseClick, theme = param.theme;
    return (0,_define_property/* default */.Z)({
        flexGrow: 1,
        paddingTop: config/* HEADER.MOBILE_HEIGHT */.yf.MOBILE_HEIGHT + 24,
        paddingBottom: config/* HEADER.MOBILE_HEIGHT */.yf.MOBILE_HEIGHT + 24
    }, theme.breakpoints.up("lg"), (0,_object_spread/* default */.Z)({
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: config/* HEADER.DASHBOARD_DESKTOP_HEIGHT */.yf.DASHBOARD_DESKTOP_HEIGHT + 24,
        paddingBottom: config/* HEADER.DASHBOARD_DESKTOP_HEIGHT */.yf.DASHBOARD_DESKTOP_HEIGHT + 24,
        width: "calc(100% - ".concat(config/* NAVBAR.DASHBOARD_WIDTH */.Au.DASHBOARD_WIDTH, "px)"),
        transition: theme.transitions.create("margin-left", {
            duration: theme.transitions.duration.shorter
        })
    }, collapseClick && {
        marginLeft: config/* NAVBAR.DASHBOARD_COLLAPSE_WIDTH */.Au.DASHBOARD_COLLAPSE_WIDTH
    }));
});
var StyledContainer = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100%"
    };
});
function AdminLayout(param) {
    var children = param.children;
    var ref = (0,useAuth/* default */.Z)(), error = ref.error, isLoading = ref.isLoading, user = ref.user, login = ref.login;
    var companyColor = (0,useApp/* default */.Z)().companyColor;
    var ref1 = (0,useCollapseDrawer/* default */.Z)(), collapseClick = ref1.collapseClick, isCollapse = ref1.isCollapse;
    var themeLayout = (0,useSettings/* default */.Z)().themeLayout;
    var isDesktop = (0,useResponsive/* default */.Z)("up", "lg");
    var ref2 = (0,react.useState)(false), open = ref2[0], setOpen = ref2[1];
    var verticalLayout = themeLayout === "vertical";
    if (isLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingScreen/* default */.Z, {
        companyColor: companyColor
    });
    if (error) return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "body2",
            sx: {
                color: "error.main"
            },
            children: error.message
        })
    });
    if (!user) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                    disabledLink: true,
                    sx: {
                        width: 250,
                        height: 250
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "contained",
                    size: "large",
                    onClick: function() {
                        return login();
                    },
                    children: "Login"
                })
            ]
        });
    }
    var _email;
    if (!appConfig/* ownerEmails.includes */.O7.includes((_email = user.email) !== null && _email !== void 0 ? _email : "")) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h4",
                    mb: 2,
                    sx: {
                        color: "error.main"
                    },
                    children: "You are not allowed to enter the admin page"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "contained",
                    size: "large",
                    href: "/",
                    children: "Go Home"
                })
            ]
        });
    }
    if (verticalLayout) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminHeader, {
                    onOpenSidebar: function() {
                        return setOpen(true);
                    },
                    verticalLayout: verticalLayout
                }),
                isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(admin_navbar_NavbarHorizontal, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarVertical_NavbarVertical, {
                    isOpenSidebar: open,
                    onCloseSidebar: function() {
                        return setOpen(false);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    component: "main",
                    sx: {
                        px: {
                            lg: 2
                        },
                        pt: {
                            xs: "".concat(config/* HEADER.MOBILE_HEIGHT */.yf.MOBILE_HEIGHT + 24, "px"),
                            lg: "".concat(config/* HEADER.DASHBOARD_DESKTOP_HEIGHT */.yf.DASHBOARD_DESKTOP_HEIGHT + 80, "px")
                        },
                        pb: {
                            xs: "".concat(config/* HEADER.MOBILE_HEIGHT */.yf.MOBILE_HEIGHT + 24, "px"),
                            lg: "".concat(config/* HEADER.DASHBOARD_DESKTOP_HEIGHT */.yf.DASHBOARD_DESKTOP_HEIGHT + 24, "px")
                        }
                    },
                    children: children
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            display: {
                lg: "flex"
            },
            minHeight: {
                lg: 1
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminHeader, {
                isCollapse: isCollapse,
                onOpenSidebar: function() {
                    return setOpen(true);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarVertical_NavbarVertical, {
                isOpenSidebar: open,
                onCloseSidebar: function() {
                    return setOpen(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(admin_MainStyle, {
                collapseClick: collapseClick,
                children: children
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/layouts/index.tsx

// guards
// components




function Layout(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "dashboard" : _variant, children = param.children;
    if (variant === "logoOnly") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LogoOnlyLayout, {
            children: [
                " ",
                children,
                " "
            ]
        });
    }
    if (variant === "main") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* default */.Z, {
            children: children
        });
    }
    if (variant === "admin") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminLayout, {
            children: children
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DashboardLayout, {
        children: [
            " ",
            children,
            " "
        ]
    });
}


/***/ }),

/***/ 69127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DY": function() { return /* binding */ fToNow; },
/* harmony export */   "Mu": function() { return /* binding */ fDate; }
/* harmony export */ });
/* unused harmony exports fDateTime, fTimestamp, fDateTimeSuffix */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32912);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2141);

// ----------------------------------------------------------------------
function fDate(date) {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(date), "dd MMMM yyyy");
}
function fDateTime(date) {
    return format(new Date(date), "dd MMM yyyy p");
}
function fTimestamp(date) {
    return getTime(new Date(date));
}
function fDateTimeSuffix(date) {
    return format(new Date(date), "dd/MM/yyyy hh:mm p");
}
function fToNow(date) {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(new Date(date), {
        addSuffix: true
    });
}


/***/ })

}]);